// base url
if (location.hostname == 'localhost' || location.hostname == 'localhost:8888') {
	var path = '/pv/';
} else {
	var path = '/';
}

var import_data = $.ajax({ type: 'GET',   
                        url: path+'data.json',   
                        async: false
                      }).responseText;
var define = JSON.parse(import_data)[0];

var token = $('html').attr('token');

$(document).ready(function() {
	if($('.editor').length > 0) {
		// init tinyMC

		tinymce.init({
			selector: '.editor',
			plugins: "autoresize link media lists advlist code help paste table",
			paste_as_text: true,
			autoresize_bottom_margin: 20,
	      	autoresize_overflow_padding: 5,
			branding: false,
			menubar:false,
			statusbar: false,
			toolbar: "undo redo | formatselect | bold italic underline forecolor fontsizeselect | alignleft aligncenter alignright alignjustify | table | bullist numlist outdent indent | removeformat | link media image | code | help",
			image_title: true,
		})
	}
	if($('.editor-quote').length > 0) {
		// contenu libre des devis (avant / après les lignes) : collage riche autorisé, tableaux repris dans le PDF avec le layout des lignes
		tinymce.init({
			selector: '.editor-quote',
			plugins: "autoresize link lists advlist code paste table",
			paste_as_text: false,
			autoresize_bottom_margin: 20,
			autoresize_overflow_padding: 5,
			branding: false,
			menubar: false,
			statusbar: false,
			block_formats: "Paragraphe=p; Titre=h2; Sous-titre=h3",
			toolbar: "undo redo | formatselect | bold italic | bullist numlist | table | removeformat | code",
			table_default_attributes: {},
			table_default_styles: { width: "100%", "border-collapse": "collapse" },
			content_style: "body { font-family: Poppins, sans-serif; font-size: 13px; color: #081f39; } table { width: 100%; border-collapse: collapse; } td, th { border: 1px solid #ddd; padding: 6px 8px; } tr:first-child td, tr:first-child th { background: #104557; color: #fff; font-weight: bold; }"
		})
	}
	if($('.tinymce').length > 0) {
		// init tinyMCE
		var hash = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');

		if(hash.indexOf('=') === -1) {
			var section = null;
		}
		else {
			var target = hash[0].split('=');
			var section = target[1].substring(0, 4);
			var section = null;
		}

		tinymce.init({
			selector: '.tinymce',
			plugins: "autoresize link image media lists advlist code help paste table",
			paste_as_text: true,
			autoresize_bottom_margin: 20,
	      	autoresize_overflow_padding: 5,
			branding: false,
			menubar:false,
			statusbar: false,
			toolbar: "undo redo | formatselect | bold italic underline forecolor fontsizeselect | alignleft aligncenter alignright alignjustify | table | bullist numlist outdent indent | removeformat | link media image | code | help",
			image_title: true,
			automatic_uploads: true,
			file_picker_types: 'image',
			file_picker_callback: function (cb, value, meta) {
				var input = document.createElement('input');
				input.setAttribute('type', 'file');
				input.setAttribute('accept', 'image/*');
				input.setAttribute('name', 'img_cont');

				input.onchange = function () {

					$('.tox-dialog').prepend('<div id="loader"><div id="spinner"></div></div>');

					var file = this.files[0];

					var reader = new FileReader();
					reader.onload = function () {

						var id = 'blobid' + (new Date()).getTime();
						var blobCache =  tinymce.activeEditor.editorUpload.blobCache;
						var base64 = reader.result.split(',')[1];
						var blobInfo = blobCache.create(id, file, base64);
						blobCache.add(blobInfo);

						var file_input = $(input).prop('files')[0];
						var formData = new FormData();
						formData.append('file', file_input);
						formData.append('section', section);

						$.ajax({
							url: 'filebrowser.php',
							dataType: 'json',  
							cache: false,
							contentType: false,
							processData: false,
							data: formData,                         
							type: 'post',
							success: function(response){

								$('.tox-dialog #loader').hide();
								
								if (response.action == "bad_ext"){
									toastr.error("Invalid extension file (accept .jpg, .jpeg, .png, .gif)");
								}
								else if (response.action == "copy_failed") {
									toastr.error("The pictures could not be copied");
								}
								else if (response.action == "success") {

									cb(response.img_path, { 
										alt: file.name,
										title: file.name
									});

								}
							}
						});

					};
					reader.readAsDataURL(file);
				};
				input.click();
			}
		});
	}

	// init toastr
	toastr.options = {
		"closeButton": true,
		"debug": false,
		"newestOnTop": false,
		"progressBar": false,
		"positionClass": "toastr-top-right",
		"preventDuplicates": true,
		"onclick": null,
		"showDuration": "300",
		"hideDuration": "1000",
		"timeOut": "2000",
		"extendedTimeOut": "1000",
		"showEasing": "swing",
		"hideEasing": "linear",
		"showMethod": "fadeIn",
		"hideMethod": "fadeOut"
	}

	// ini flatpicker
	function datepicker() {
		if($(".datepicker").length) {
			$(".datepicker").flatpickr({
				dateFormat: "d-m-Y",
				'locale' : {
			    	"firstDayOfWeek": 1 // start week on Monday
				}, 
				static: true,
				locale: 'fr',
				plugins: [
				    ShortcutButtonsPlugin({
			      		button: [
					        {
				          		label: "Today"
					        }
				      	],
				      	onClick: (index, fp) => {
			        		fp.setDate(moment(new Date()).format("DD/MM/YYYY"));
			      		}
				    })
			  	]
			});
		}
	}

	datepicker();

	// ini flatpicker multi
	function datepicker_multi() {
		if($(".datepicker-multi").length) {
			$(".datepicker-multi").flatpickr({
			    mode: "multiple",
			    dateFormat: "Y-m-d"
			});
		}
	}
	datepicker_multi();



	$(".datetimepicker").flatpickr({
	    enableTime: true,
		dateFormat: "d-m-Y H:i",
		time_24hr: true,
		minuteIncrement: 15,
		static: true,
		'locale' : {
	    "firstDayOfWeek": 1 // start week on Monday
		}
	});

	// init Date range picker
	$(".rangepicker").daterangepicker({
		autoApply: true,
		locale: {
			format: 'DD/MM/YYYY',
    		firstDay: 1
    	}
	});

	// ini max length counter
	$('.counter').maxlength({
	    warningClass: "badge badge-success",
	    limitReachedClass: "badge badge-danger"
	});

	// init mask
	Inputmask("BE 9999.999.999", {
	    "numericInput": true
	}).mask(".vat");

	function commaSeparateNumber(val) {
		  // remove sign if negative
		  var sign = 1;
		  if (val < 0) {
		    sign = -1;
		    val = -val;
		  }

		  // trim the number decimal point if it exists
		  let num = val.toString().includes('.') ? val.toString().split('.')[0] : val.toString();

		  while (/(\d+)(\d{3})/.test(num.toString())) {
		    // insert comma to 4th last position to the match number
		    num = num.toString().replace(/(\d+)(\d{3})/, '$1' + '.' + '$2');
		  }

		  // add number after decimal point
		  if (val.toString().includes('.')) {
		    num = num + '.' + val.toString().split('.')[1];
		  }

		  // return result with - sign if negative
		  return sign < 0 ? '-' + num : num;
	}

	// init datatable
	/*if($('body').find('.data-table').length>0) {
		//var language = $('html').attr('lang');
		$('.data-table').DataTable({
			responsive: true,
			fixedHeader: {
				header: false,
				footer: true
			},
           "pageLength": 25,
           "aaSorting": []
      });

		$.fn.dataTable.moment = function ( format, locale ) {
			var types = $.fn.dataTable.ext.type;
			
		    // Add type detection
		    types.detect.unshift( function ( d ) {
		    	return moment( d, format, locale, true ).isValid() ?
		    	'moment-'+format :
		    	null;
		    } );
		    
		    // Add sorting method - use an integer for the sorting
		    types.order[ 'moment-'+format+'-pre' ] = function ( d ) {
		    	return moment( d, format, locale, true ).unix();
		    };
		};

		$.fn.dataTable.moment( 'DD-MM-YYYY' );
	}





	function table_order(path, folder) {
		if($('body').find('.data-table-'+folder+'-order').length>0) {
	        var table = $('.data-table-'+folder+'-order').DataTable({
	            rowReorder: true,
	            "pageLength": 25
	        });

	        table.on( 'row-reorder', function ( e, diff, edit ) {

		        var order_arr = new Array;	

		        $('.data-table-'+folder+'-order tbody tr').each(function() {
		        	order_arr.push($(this).data('id'));
		        });

		        $.post(path+'request/xhr/'+folder+'/order.php', {order_arr: order_arr, token: token}, function(response) {
		        }, 'json');
		    } );
		}
	}*/

	// personnalise les datas à transmettre en dehors d'un serializeArray() dans la fonction xhr_send()
	function xhr_data(file = null, data, $this) {
		switch(file) {
			case 'content/get-image':
		    	data[data.length] = { name: 'id', value: $this.data('id') };
		    	data[data.length] = { name: 'folder', value: $this.data('folder') };
		    	break;

		    case 'content/select-image':
		    	data[data.length] = { name: 'id', value: $this.data('id') };
		    	data[data.length] = { name: 'uniqid', value: $this.closest('#file-result').data('id') };
		    	break;

		    case 'files/get-file' :				
		    	data[data.length] = { name: 'id', value: $this.data('id') };
		    	break;

	       	case 'ticket/get-ticket' :
	       		var id = $this.closest('[data-id]').data('id');
		    	data[data.length] = { name: 'id', value: id };
	       		break;

	       	case 'sav/get-sav' :
	       		var id = $this.closest('[data-id]').data('id');
		    	data[data.length] = { name: 'id', value: id };
	       		break;

	       	case 'quote/save-quote' :
	       		var action = $this.data('action');
	       		var wc = $('#wc');
		    	data[data.length] = { name: 'action', value: action };
				break;

		    case 'contact/check-vat' :
				$this.closest('form').find('#vatHelp span').addClass('d-none');
				$this.closest('form').find('#vatHelp span.loading-text').removeClass('d-none');
				break;
			case 'invoice/add-deposit':

				swal_text = `<p class="text-start">En validant, vous allez générer la facture d'acompte.</p>
							<p class="text-start">Souhaitez-vous archiver les autres devis de cette opportunité ?</p>
		                    <div class="form-check mb-5 mt-3 mb-2 d-flex">                 
		                        <input class="form-check-input me-5" type="checkbox" id="archive-quote" name="archive-quote" value="1">
		                        <label class="form-check-label" for="archive-quote">Oui, archivez</label>
		                    </div>`;
		        swal_confirm= `Générer la facture d'acompte`;

		        if($('#archive-quote').is(':checked')) {
		    		var archive = 1;
		    	}			
		    	else {
		    		var archive = 0;
		    	}

		    	if(data.find(e => e.name == 'archive')) {
		    		// var values = $("#frmblog").serializeArray();
					data.find(input => input.name == 'archive').value = archive;
		    	}
		    	else {
					data[data.length] = { name: 'archive', value: archive };
				}

				data[data.length] = { name: 'deposit', value: 1 };

		    	break;

	    	case 'invoice/send-peppol-invoice':

				swal_text = `<p class="text-start">En validant, vous allez envoyer la facture au service Peppol.</p>
							<p class="text-start">Attention, cette action est irréversible</p>`;
		        swal_confirm= `Envoyer à Peppol`;

		    	break;

			case 'invoice/send-invoice':
				const send = $this.data('send');
	            data.push({ name: 'send', value: send });
	            swal_text = `<p>Souhaitez-vous envoyer la facture ?</p>`;
	            swal_confirm = `Oui, c'est parti`;

		    	break;

			case 'invoice/send-nc':

				swal_text = `<p>Souhaitez-vous envoyer la note de crédit dans Winbooks ?</p>`;
		        swal_confirm= `Oui, c'est parti`;

		    	break;

			case 'invoice/paied-invoice':

				swal_text = `<p class="text-start">Indiquer cette facture comme payée ?</p>
		                    
                			<div class="mb-5">
		                        <label class="form-label required" for="paied-at">Date de paiement</label>
		                        <input type="text" class="form-control form-control-solid datepicker" id="paied-at" name="paied-at">
		                    </div> `;
		        swal_confirm= `Facture payée`;

		    	data[data.length] = { name: 'invoice', value: $this.closest('[data-id]').data('id') };
		    	data[data.length] = { name: 'paied-at', value: $('#paied-at').val() };

		    	break;

			case 'invoice/refresh-invoice':

				swal_text = `<p class="text-start">Voulez-vous regénérer cette facture ?</p>`;
		        swal_confirm= `Regénérer la facture`;

		    	break;

			case 'invoice/nc-invoice':

				swal_text = `<p class="text-start">Voulez-vous créer une note de crédit pour cette facture ?</p>`;
		        swal_confirm= `Créer la note de crédit`;

		    	break;

			case 'todo/reminder':

				swal_text = `<p class="text-start">Voulez-vous modifier la date de rappel ?</p>
		                    
                			<div class="mb-5">
		                        <label class="form-label required" for="reminder">Date de rappel</label>
		                        <input type="text" class="form-control form-control-solid datepicker" id="reminder" name="reminder">
		                    </div> `;
		        swal_confirm= `Modifier`;

				data[data.length] = { name: 'reminder', value: $('#reminder').val() };

		    	break;

			case 'quote/update-signed':

				swal_text = `<p class="text-start">Le devis a-t-il été signé par le client ?</p>
							<p class="text-start">Souhaitez-vous archiver les autres devis de cette opportunité ?</p>
		                    <div class="form-check mb-5 mt-3 mb-2 d-flex">                 
		                        <input class="form-check-input me-5" type="checkbox" id="archive-quote" name="archive-quote" value="1">
		                        <label class="form-check-label" for="archive-quote">Oui, archivez</label>
		                    </div>`;
		        swal_confirm= `Mettre le statut à jour`;

		        if($('#archive-quote').is(':checked')) {
		    		var archive = 1;
		    	}			
		    	else {
		    		var archive = 0;
		    	}

		    	if(data.find(e => e.name == 'archive')) {
		    		// var values = $("#frmblog").serializeArray();
					data.find(input => input.name == 'archive').value = archive;
		    	}
		    	else {
					data[data.length] = { name: 'archive', value: archive };
				}

				break;

			case 'invoice/add-invoice-deposit':

				swal_text = `<p class="text-start">Souhaitez-vous éditer cette facture ?</p>`;
				swal_confirm= `Oui`;
		        
		    	data[data.length] = { name: 'block', value: $this.data('block') };
		    	data[data.length] = { name: 'id-quote', value: $this.closest('[data-id]').data('id') };

				break;

			case 'worksite/check-worksite':
		    	data[data.length] = { name: 'id', value: $this.closest('[data-id]').data('id') };
		    	break;

			case 'worksite/add-cadastre':
		    	data[data.length] = { name: 'id', value: $this.data('address') };
		    	data[data.length] = { name: 'cadastre', value: $('#cadastre').val() };
		    	break;

			case 'worksite/add-panel-serial':
		    	data[data.length] = { name: 'id', value: $('#id').val() };
		    	data[data.length] = { name: 'panel-serial', value: $('#panel-serial').val() };
		    	break;

			case 'worksite/delete-team':
		    	data[data.length] = { name: 'team', value: $this.closest('div').find('.id-team').val() };
		    	break;

			case 'contact/get-distance-matrix':
				if($('#kt_customer_view_details').hasClass('open')) {
					var open = true;
				}
				else {
					var open = false;
				}

		    	data[data.length] = { name: 'open', value: open };
		    	break;

		    case 'quote/update-quote-deposit' :
		    	var block = new Array();
				$('[data-block]').each(function() {
					if(!$(this).hasClass('locked')) {
						block.push($(this).data('block'));
					}
				});

				console.log(block);
				console.log(Array.isArray(block)); // Should log true


				data[data.length] = { name: 'block', value: block };
				// data.push({ ['block']: block });

		    	break;

			/*case 'worksite/update-insurance':
		    	data[data.length] = { name: 'id', value: $('[data-worksite]').data('worksite') };
		    	
		    	if($('#insurance').is(':checked')) {
		    		var insurance = 1;
		    	}			
		    	else {
		    		var insurance = 0;
		    	}

		    	data[data.length] = { name: 'insurance', value: insurance };
		    	break;

			case 'worksite/update-panel-serial':
		    	data[data.length] = { name: 'id', value: $('[data-worksite]').data('worksite') };
		    	
		    	if($('#panel-serial').is(':checked')) {
		    		var panel_serial = 1;
		    	}			
		    	else {
		    		var panel_serial = 0;
		    	}

		    	data[data.length] = { name: 'panel-serial', value: panel_serial };
		    	break;

		    case 'worksite/update-controle':
		    	data[data.length] = { name: 'id', value: $('[data-worksite]').data('worksite') };
		    	
		    	if($('#controle').is(':checked')) {
		    		var controle = 1;
		    	}			
		    	else {
		    		var controle = 0;
		    	}

		    	data[data.length] = { name: 'controle', value: controle };
		    	break;*/

		    default:
		    	return true;
	    }
	}

	// personnalise les callback en cas de succès dans la fonction xhr_send()
	function xhr_success(callback = null, response, data, path, $this) {
		var dataObj = {};
		for (i = 0; i < data.length; i++) {
			dataObj[data[i].name] = data[i].value;
		}

		switch(callback) {
			case 'settings/update-keys':
				if(dataObj['id'] != '') {
					$('tr[data-id='+dataObj['id']+'] .dev').html(dataObj['dev']);
					$('tr[data-id='+dataObj['id']+'] .prod').html(dataObj['prod']);
					if(dataObj['public'] == 1) {
						$('tr[data-id='+dataObj['id']+'] .public').html('<i class="fa fa-check text-success"></i>');
					}
					else {
						$('tr[data-id='+dataObj['id']+'] .public').html('<i class="fa fa-times text-danger"></i>');
					}
				}
				else {
					setTimeout(function() {
						location.reload();
					}, 3000);
				}
				toastr.success(response.msg);
				$('#modal-keys').modal('hide');
		    	break;

		    case 'keyword/update-keyword':
		    	toastr.success(response.msg);
				$('#modal-keyword').modal('hide');

		    	if($('[data-id='+dataObj['id_keyword']+']').length > 0) {
					$.each(dataObj, function( index, value ) {
						if(index != 'id_keyword' && index != 'token' && index != 'public') {
							$('[data-id='+dataObj['id_keyword']+'] .'+index).html(value);
						}					
					});

			    	if(dataObj['public'] == 1) {
						$('tr[data-id='+dataObj['id_keyword']+'] .public').html('<i class="fa fa-check text-success"></i>');
					}
					else {
						$('tr[data-id='+dataObj['id_keyword']+'] .public').html('<i class="fa fa-times text-danger"></i>');
					}
				}
				else {
					location.reload();
				}
		    	break;
		    case 'content/get-image':
		    	$('#modal-get-image .modal-body').html(response.html);
		    	filemanager_dropzone(path, 'content-manager');
		    	if(!$('#modal-get-image').is(':visible')) {
			    	$('#modal-get-image').modal('show');
		    	}
		    	break;

	    	case 'content/select-image':
		    	$('#modal-get-image').modal('hide');
		    	$('#preview-'+response.uniqid).html(response.html);
		    	$('#preview-'+response.uniqid).closest('[data-hook]').find('input[name=image]').val(response.id)
		    	break;

		    case 'files/get-file' :
		    	$('#modal-update-file').modal('show');
				$('#modal-update-file .modal-title span').html(response.file.filename);

				var form = '#modal-update-file #form-update-file';
				$(form).find('input').val('');

				$.each(response.file, function(i, item) {
					if($(form).find('#'+i).prop('tagName') == 'INPUT') {
				    	$(form).find('#'+i).val(item);
				    }
				    else {
						$(form).find('#'+i).text(item);
				    }
				});

				$('#modal-update-file #download').attr('href', response.file.link);

				$('#modal-update-file #alt').addClass('d-none');
				$('#modal-update-file #dimension').addClass('d-none');
				$('#modal-update-file #delete-file').data('id', response.file.id);

				$('#modal-update-file #preview').removeClass('light dark');
				$('#modal-update-file #preview').addClass('light');

				$('#modal-update-file [data-mode]').removeClass('d-none');
				$('#modal-update-file [data-mode=light]').addClass('d-none');

				if(response.file.type == 'image') {
					$('#modal-update-file #alt').removeClass('d-none');
					$('#modal-update-file #dimension').removeClass('d-none');
					$('#modal-update-file #preview').html('<img src="/dist/assets/'+response.file.path+response.file.filename+'" class="mh-100 mw-100">');
				}
				else if(response.file.type == 'video') {
					$('#modal-update-file #preview').html('<video controls id="video-preview" style="width: 100%; height: 100%; margin:0 auto; frameborder:0;"><source src="" type="video/mp4">Your browser doesn\'t support HTML5 video tag.</video>');

					$('#modal-update-file').find('source').attr('src', '/dist/assets/'+response.file.path+response.file.filename+ '?autoplay=1&amp;modestbranding=1&amp;showinfo=0');
					$('#video-preview')[0].load();
					$('#modal-update-file').modal('show');
					// $('#video-preview')[0].play();
					$('#video-preview').prop('muted', true);

					$('#modal-update-file').on('hidden.bs.modal', function () {
						$('#video-preview')[0].pause();
					});
				}
				else if(response.file.ext.toLowerCase() == 'pdf') {
					$('#modal-update-file #preview').html('<iframe src="/dist/assets/img/'+response.file.path+response.file.filename+'" class="h-100 w-100"></iframe>');
				}
				else{
					$('#modal-update-file #preview').html('<i class="fa-duotone fa-file fa-2xl text-primary"></i>');
				}

				break;

			case 'ticket/get-default-ticket' :
				$('#modal-ticket input[type="text"]').val('');

				$.each(response.ticket, function(key, value) {
					$('#modal-ticket #' + key).val(value);
				});
					
				$('#modal-ticket #bug').prop('checked', false);

				$('#modal-ticket [data-control="select2"]').trigger('change.select2'); 

				$('#modal-ticket').modal('show'); 

				break;

			case 'ticket/get-ticket' :
				$('#modal-ticket input[type="text"]').val('');

				$.each(response.ticket, function(key, value) {
					$('#modal-ticket #' + key).val(value);
				});

				if(response.ticket.bug == 1) {					
					$('#modal-ticket #bug').prop('checked', true);
				}
				else {
					$('#modal-ticket #bug').prop('checked', false);
				}


				$('#modal-ticket .ticket-nbr').html('#'+response.ticket.id);

				$('#modal-ticket [data-control="select2"]').trigger('change.select2'); 

				$('#modal-ticket').modal('show'); 

				break;

			case 'ticket/last-seen' :
				$('#last-seen-bullet').remove();
				break;

			case 'sav/get-default-sav' :
				$('#modal-sav input[type="text"]').val('');

				$.each(response.sav, function(key, value) {
					$('#modal-sav #' + key).val(value);
				});
					
				$('#modal-sav #bug').prop('checked', false);

				$('#modal-sav [data-control="select2"]').trigger('change.select2'); 

				$('#modal-sav').modal('show'); 

				break;

			case 'sav/get-sav' :
				$('#modal-sav input[type="text"]').val('');

				$.each(response.sav, function(key, value) {
					$('#modal-sav #' + key).val(value);
				});

				if(response.sav.bug == 1) {					
					$('#modal-sav #bug').prop('checked', true);
				}
				else {
					$('#modal-sav #bug').prop('checked', false);
				}


				$('#modal-sav .sav-nbr').html('#'+response.sav.id);

				$('#modal-sav [data-control="select2"]').trigger('change.select2'); 

				$('#modal-sav').modal('show'); 

				break;

			case 'sav/last-seen' :
				$('#last-seen-bullet').remove();
				break;

			case 'quote/save-quote' :
				if(response.quote_url != null) {
					history.replaceState(null, '', response.quote_url);
				}

				$('#id-quote').val(response.quote);

				if(response.tab != null) {
					window.open(response.tab, '_blank');
				}

		    	toastr.success(response.msg);

				break;

			case 'quote/save-technical':
				$('#last-update').removeClass('d-none');
				$('#last-update span').html(response.time);

				$.each(response.status, function(key, value) {
					if(value == true) {
						$('#'+key+'-tab span').removeClass('d-none');
					}
					else {
						$('#'+key+'-tab span').addClass('d-none');
					}
				});

				break;
			case 'contact/check-vat' :
				$.each(response.json_formated, function( index, value ) {
					if(index != 'id_keyword' && index != 'token') {
						$('#'+index).val(value);
					}					
				});
				$this.closest('form').find('#vatHelp span').removeClass('d-none');
				$this.closest('form').find('#vatHelp span.loading-text').addClass('d-none');

				break;

			case 'quote/archive-quote':
				$this.closest('tr').remove();

		    	break;

		    case 'invoice/get-tracking':
		    	
	            $('#modal-email-tracking .modal-body').html(response.html);
	            $('#modal-email-tracking').modal('show');
	        
	        	break;

			case 'worksite/save-worksite':
				console.log('hello')
				$.each(response.team, function( index, value ) {
					$('[data-repeater-item]:nth-child('+(parseInt(index) + 1 )+')').find('[data-kt-repeater="id-team"]').val(value);
				});

		    	break;

		    case 'home/search':
		    	if(response.status == 'empty') {
		    		$('[data-kt-search-element="results"]').addClass('d-none');
		    		$('[data-kt-search-element="empty"]').addClass('d-none');
		    	}
		    	else if(response.status == 'no-result') {
		    		$('[data-kt-search-element="results"]').addClass('d-none');
		    		$('[data-kt-search-element="empty"]').removeClass('d-none');
		    	}
		    	else {
			    	$('[data-kt-search-element="results"]').removeClass('d-none');
		    		$('[data-kt-search-element="empty"]').addClass('d-none');
		    		$('#header-search-result').html(response.output);
			    }

		    	break;

		    case 'contact/get-distance-matrix':

				if(!$('#kt_customer_view_details').hasClass('open')) {
			    	$('#matrix-etienne .distance').html(response.etienne.distance.text);
			    	$('#matrix-etienne .duration').html(response.etienne.duration.text);
			    	$('#matrix-pascal .distance').html(response.pascal.distance.text);
			    	$('#matrix-pascal .duration').html(response.pascal.duration.text);

			    	$('#kt_customer_view_details').addClass('open');
			    }

		    	break;

			default:
				return true;
		}

	}

	// fonction principale pour l'envoie et le controle de requêtes ajax
	function xhr_send(path, token, $this) {
		var file = $this.data('xhr');
		
		if($this.prop('tagName') == 'BUTTON' && $this.is('[data-kt-indicator]')) {
			var loading = true;
			var text = $this.find('.indicator-label').html();
		}else {
			var loading = false;
		}

		if($this.data('type') !== undefined) {
			var type = $this.data('type');
		}
		else {
			var type = null;
		}
		var form = '#'+$this.closest('form').attr('id');

		var data = $(form).serializeArray();
		data[data.length] = { name: 'token', value: token };

		$('.tinymce').each(function() {
			var currentEditorId = $(this).attr('id');
			var val = tinyMCE.get($(this).attr('id')).getContent();

			for (index = 0; index < data.length; ++index) {
			    if (data[index].name == currentEditorId) {
			        data[index].value = val;
			    }
			}
		});

		xhr_data(file, data, $this);

		$('.is-invalid').removeClass('is-invalid');

		if(type == 'delete' || type == 'alert') {
			var id = $this.closest('[data-id]').data('id');
			data[data.length] = { name: 'id', value: id };

			if (typeof swal_text == 'undefined') {
				swal_text = 'Êtes-vous certain de vouloir supprimer cet enregistrement ?';
			}

			if (typeof swal_icon == 'undefined') {
				swal_icon = 'warning';
			}

			if (typeof swal_confirm == 'undefined') {
				swal_confirm = 'Oui, supprimez-le !';
			}

			if (typeof swal_cancel == 'undefined') {
				swal_cancel = 'Non, retour';
			}

			if (typeof swal_confirm_btn == 'undefined') {
				swal_confirm_btn = 'btn-primary';
			}

			Swal.fire({
                html: swal_text,
                icon: swal_icon,
                showCancelButton: true,
                buttonsStyling: false,
                confirmButtonText: swal_confirm,
                cancelButtonText: swal_cancel,
                customClass: {
                    confirmButton: "btn "+swal_confirm_btn,
                    cancelButton: "btn btn-active-light"
                }
            }).then(function (result) {
                if (result.value) {

					xhr_data(file, data, $this);

                    $.post(path+'request/xhr/'+file+'.php', data, function(response, statusText, jqXHR) {
						if(response.action == 'success') {

							if(response.callback === true) {
								xhr_success(file, response, data, path);
							}
							else {
								if(response.msg != null) {
									toastr.success(response.msg);
								}

								if(type == 'delete') {
									$this.closest('[data-id]').remove()					
								}
							}

							if(response.url != null) {
								if(response.msg != null) {								
									setTimeout(function() {
										if(response.url == 'reload') {
											location.reload();
										}
										else {
											location.href = response.url;
										}
									}, 1500);
								}
								else {
									if(response.url == 'reload') {
										location.reload();
									}
									else {
										location.href = response.url;
									}
								}
							}
						}
						else if(response.action == 'empty') {
							if(response.msg != null) {
								toastr.warning(response.msg);
							}
						}
						else if(response.action == 'token' || response.token === null) {
							location.reload();
						}   
						else {
							if(response.msg != null) {
								toastr.error(response.msg);
							}
							$.post(path+'request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'front', debug:true, token: token}, function(response2) {}, 'json');
						}
					}, 'json')
					.always(function(jqXHR) {
					    if(jqXHR.status == 404) {
							$.post(path+'request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'front', token: token}, function(response2) {}, 'json');
					    }
					    else if(jqXHR.status == 500) {			    	
							toastr.error('Request error. Please contact the support');

							$.post(path+'request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'admin', token: token}, function(response2) {}, 'json');
					    }
					});
                }
            });

            datepicker();
		}
		else {
			var data = $(form).serializeArray();
			data[data.length] = { name: 'token', value: token };

			if($this.closest('[data-id]').data('id')) {
				var id = $this.closest('[data-id]').data('id');
				data[data.length] = { name: 'id', value: id };
			}

			$('.tinymce').each(function() {
				var currentEditorId = $(this).attr('id');
				var val = tinyMCE.get($(this).attr('id')).getContent();

				for (index = 0; index < data.length; ++index) {
				    if (data[index].name == currentEditorId) {
				        data[index].value = val;
				    }
				}
			});

			$('.editor, .editor-quote').each(function() {
				var currentEditorId = $(this).attr('id');
				var val = tinyMCE.get($(this).attr('id')).getContent();

				for (index = 0; index < data.length; ++index) {
				    if (data[index].name == currentEditorId) {
				        data[index].value = val;
				    }
				}
			});

			xhr_data(file, data, $this);

			$('.is-invalid').removeClass('is-invalid');
			$.post(path+'request/xhr/'+file+'.php', data, function(response, statusText, jqXHR) {
				if(response.action == 'success') {
					if(response.callback === true) {
						xhr_success(file, response, data, path, $this);
					}
					else {
						if(response.msg != null) {
							toastr.success(response.msg);						
						}
					}

					if(response.url != null) {
						if(response.msg != null) {								
							setTimeout(function() {
								if(response.url == 'reload') {
									location.reload();
								}
								else {
									location.href = response.url;
								}
							}, 1500);
						}
						else {
							if(response.url == 'reload') {
								location.reload();
							}
							else {
								location.href = response.url;
							}
						}
					}
				}
				else if(response.action == 'empty') {
					if(response.msg != null) {
						toastr.warning(response.msg);
					}

					$.each(response.fields, function(i, item) {
					    $(form).find('#'+item).addClass('is-invalid');
					});
				}
				else if(response.action == 'token' || response.token === null) {
					location.reload();
				}
				else {
					if(response.msg != null) {
						toastr.error(response.msg);
					}

					$.post(path+'request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'admin', debug:true, token: token}, function(response2) {}, 'json');
				}

				if(loading == true) {
					setTimeout(function() {				        
						$this.attr("data-kt-indicator", "off");
						$this.html(text.replace('Please wait...', ''));
				    }, 300);
				}

			}, 'json')
			.always(function(jqXHR) {
			    if(jqXHR.status == 404) {
					$.post(path+'request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'front', token: token}, function(response2) {}, 'json');
					location.href = 'index.php';
			    }
			    else if(jqXHR.status == 500) {			    	
					toastr.error('Request error. Please contact the support');

					$.post(path+'request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'admin', token: token}, function(response2) {}, 'json');
			    }
			});
		}
	}

	// bind un click sur les éléments portant le [data-xhr]
	$(document).on('click', '[data-xhr]', function(e) {
		var $this = $(this);

		if($this.data('trigger') === undefined) {
			if(!$this.is(':checkbox')) {
				e.preventDefault();
			}

			if($this.prop('tagName') == 'BUTTON') {
				var text = $this.text();

				$this.html('<span class="indicator-label">'+text+'</span><span class="indicator-progress">Please wait... <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>');		
				$this.attr("data-kt-indicator", "on");
			}

			xhr_send(path, token, $this);
		}
	});

	// bind un click sur les éléments portant le [data-xhr]
	$(document).on('change', '#form-technical input, #form-technical select, #form-technical textarea', function(e) {
		var $this = $(this).closest('form');
		xhr_send(path, token, $this);
	});

	function get_stock_product() {
		if($('.stock-product').length > 0) {
			$('.stock-product').each(function() {
				var id = $(this).find('select').val();
				var quantity = $(this).find('.quantity').val();
				var worksite = $('#id').val();
				var $this = $(this);

				$.post(path+'request/xhr/worksite/get-stock-product.php', {id:id, quantity: quantity, worksite:worksite, token: token}, function(response){
					if(response.action=='success') {
						if(response.quantity < 0) {
							$this.find('.stock-warning').removeClass('d-none');						
							$this.find('.stock-warning span').html(response.quantity_output);		
							$this.find('input[type=checkbox]').addClass('d-none');	
						}
						else {
							$this.find('.stock-warning').addClass('d-none');	
							$this.find('input[type=checkbox]').removeClass('d-none');	
						}
					}
					else if(response.action=='empty') {
						toastr.warning(response.msg);
					}
					else if(response.action == 'token' || response.token === null) {
						location.reload();
					}    
					else {
						toastr.error(response.msg);
					}
				}, 'json');
			});
		}
	}

	get_stock_product();

	$('#worksite-team-repeater').repeater({
	    initEmpty: false,

	    defaultValues: {
	        'text-input': 'foo'
	    },

	    show: function () {
	        $(this).slideDown();

	        // Re-init select2
	        $(this).find('[data-kt-repeater="select2"], [data-kt-repeater="job"]').select2();

	        // Re-init flatpickr
	        $(this).find('[data-kt-repeater="datepicker"]').flatpickr({mode: "multiple"});
	    },

	    hide: function (deleteElement) {
	        $(this).slideUp(deleteElement);
	    },

	    ready: function(){
	        // Init select2
	        $('[data-kt-repeater="select2"], [data-kt-repeater="job"]').select2();

	        // Init flatpickr
	        $('[data-kt-repeater="datepicker"]').flatpickr({mode: "multiple"});
	    }
	});

	// bind un click sur les éléments portant le [data-xhr]
	$(document).on('change', '#form-update-worksite input, #form-update-worksite select, #form-update-worksite textarea', function(e) {
		var $this = $(this).closest('form');
		get_stock_product();
		xhr_send(path, token, $this);
	});

	// bind un click sur les éléments portant le [data-xhr]
	$(document).on('keyup', '#header-search input', function(e) {
		var $this = $(this).closest('form');
		xhr_send(path, token, $this);
	});

	$(document).on('change', '#vat', function(e) {
		var $this = $(this);

		xhr_send(path, token, $this);
	});

	

	$('.delete').click(function(e){
		if (confirm('Voulez-vous vraiment supprimer ceci?')) {
			$(this).next('form').submit();
		}
		e.preventDefault();
	});

	// gestion des leads client
	$(document).on('change', '#form-add-lead #lead', function() {

		$('#lead-client, #lead-network').addClass('d-none');

		// client
		if($(this).val() == '5') {
			$('#lead-client').removeClass('d-none');
		}

		// network
		if($(this).val() == '6') {
			$('#lead-network').removeClass('d-none');
		}
	});

	$(document).on('click', '.test', function(e) {
		e.preventDefault();
    	$.get(path+'template/section/_builder.php', {id: '12'}, function(response) {
    		$('#section_target').append(response.replace('[rel]', ''));
    		// $('#section-modal').modal('toggle');
    		$("html, body").animate({ scrollTop: $(document).height() }, 1000);

			$.get(path+'template/section/control/code.php', function(response) {
	    		$('#editor').parent().html(response.replace('[content]', ''));
	    		
	    	});

    	});    		
    });
    // ajout et construction d'une section
    $(document).on('click', '.line', function() {
    	var id = $(this).attr('id').split('_')[1];
    	$.get(path+'template/section/_builder.php', {id: id}, function(response) {
    		$('#section_target').append(response.replace('[rel]', ''));
    		$('#section-modal').modal('toggle');
    		$("html, body").animate({ scrollTop: $(document).height() }, 1000);
    	});    		
    });

    // ajout et construction d'une section
    $(document).on('click', '#section_target section', function() {
    	$('#section_target section').removeClass('active');
    	$(this).addClass('active');
    	$('.section-option').slideDown('fast');

    	// ajuster le checkbox fluid
    	if($(this).find('.control').hasClass('class_fluid')) {
    		$('.section-option').find('#fluid').prop('checked', true);
    	}
    	else {
    		$('.section-option').find('#fluid').prop('checked', false);
    	}

    	$('.section-option').find('#id_class').val($(this).find('.control').attr('rel'));
    });

    $(document).on('click', '.close-section', function () {
    	$('#section_target section').removeClass('active');
    	$(".section-option").slideUp('fast');
    });

    $(document).on('click', '#fluid', function () {
    	if($(this).is(':checked')) {
    		$('section.active .control').addClass('class_fluid');
    	}
    	else {			
    		$('section.active .control').removeClass('class_fluid');
    	}
    });

    $(document).on('change', '#id_class', function () {
    	var val = $(this).val();
    	$('section.active .control').attr('rel', val);
    });

    $(document).on('click', '#editor button', function(e) {  
    	var $this= $(this);  	
    	var type = $(this).data('type');

    	$.get(path+'template/section/control/'+type+'.php', function(response) {
    		$this.closest('#editor').parent().html(response.replace('[content]', ''));
    		if(type == 'text') {
    			tinymce.init({
    				selector: '.tinymce',
    				plugins: "autoresize link lists advlist code",
    				autoresize_bottom_margin: 20,
    				branding: false,
    				menubar:false,
    				statusbar: false,
    				toolbar: "undo redo | formatselect | bold italic underline forecolor fontsizeselect | alignleft aligncenter alignright alignjustify | table | bullist numlist outdent indent | removeformat | link media image | code | help"
    			});
    		}
    	});

    	e.preventDefault();
    });

    $(document).on('submit', '#form_image', function(e) {
    	$this = $(this);
    	var formData = new FormData(this);
    	formData.append("type", "img");

    	$.ajax({
    		url: path+"request/xhr/upload/upload.php?input=image&folder=content%2F",
    		type: "POST",
    		data:  formData, 
    		dataType: 'json',
    		contentType: false,
    		cache: false,
    		processData:false,
    		beforeSend : function()
    		{
			//$("#preview").fadeOut();
			$("#err").fadeOut();
		},
		success: function(response)
		{				

			var filename = response.filename;
			var ext = response.ext;
			var id = response.id;
			$.get(path+'template/section/template/img.php', function(data) {
				$this.find('.preview').html(data.replace('[src]', '../dist/assets/files/content/'+ filename+'_md.'+ext).replace('[id]', id));

						//'<img src="../files/'+ response.filename+'_m.'+response.ext+'" class="img-fluid" /><input name="img" type="hidden" value="'+response.id+'" />');
					});

				//$this.closest('[data-type]').find('.preview').html('<img src="../files/'+ response.filename+'_m.'+response.ext+'" class="img-fluid" /><input name="img" type="hidden" value="'+response.id+'" />');
			},
			error: function(e) 
			{
				toastr.error(response.msg);
			}          
		});


    	e.preventDefault();
    	return false;
    });

    // ajout d'une image dans le hook depuis la librairie media
    $(document).on('click', '.choose-pic', function(e) {
    	var id = $(this).data('pic');
    	var src = $(this).attr('rel');

    	$(this).closest('[data-type]').find('input[name="img"]').val(id);
    	$(this).closest('[data-type]').find('.preview img').attr('src', src);

    	$('#choose-pic-modal').modal('toggle');
    });

    $('.custom-file-input').on('change', function() {
    	let fileName = $(this).val().split('\\').pop();
    	$(this).siblings('.custom-file-label').addClass('selected').html(fileName);
    });

    $(document).on('submit', '#form_file', function(e) {
    	$this = $(this);

    	$.ajax({
    		url: path+"request/xhr/content/upload.php",
    		type: "POST",
    		data:  new FormData(this), 
    		dataType: 'json',
    		contentType: false,
    		cache: false,
    		processData:false,
    		beforeSend : function()
    		{
			//$("#preview").fadeOut();
			$("#err").fadeOut();
		},
		success: function(response)
		{	
			location.reload();
		},
		error: function(e) 
		{
			toastr.error(response.msg);
		}          
	});


    	e.preventDefault();
    	return false;
    });

	// save template et contenu
	$(document).on('click', '#update-content', function(e) {
		var page = $('input[name=page]').val();	
		var lang = $('input[name=lang]').val();
		var menu_title = $('input[name=menu_title]').val();
		var admin_title = $('input[name=admin_title]').val();

		if($("#Online_page").is(':checked')) {
			var show = 1;
		}
		else {
			var show = 0;
		}

		if($("#secure_login").is(':checked')) {
			var secure_login = 1;
		}
		else {
			var secure_login = 0;
		}	

		if($("#secure").is(':checked')) {
			var secure = 1;
		}
		else {
			var secure = 0;
		}	

		if($("#Menu_visible").is(':checked')) {
			var menu = 1;
		}
		else {
			var menu = 0;
		}

		var menu_id = $('#Menu_id').val();	

		var structure = [];
		var content = [];
		var type = [];
		var val = [];
		var hook = [];
		var fluid = [];
		var add_class = [];
		var i = 0;
		
		$('#section_target section').each(function() {
			structure[i] = $(this).attr('id').split('_')[1];

			// gestion class fluid
			if($(this).find('.control').hasClass('class_fluid')) {
				fluid[i] = 1;
			}
			else {
				fluid[i] = 0;
			}

			// ajout de class/id
			if($(this).find('.control').attr('rel') !== undefined) {
				add_class[i] = $(this).find('.control').attr('rel');
			}
			else {
				add_class[i] = 'null';	 		
			}

			console.log(add_class[i]);
			
			var type_section = [];
			var val_section = [];
			var j = 0;
			$('div[data-type]', this).each(function() {
				type_section[j] = $(this).data('type');
				type[i] = type_section;

				if($(this).data('type') == 'code') {
					var $this = $(this);
					var hook_section = [];

					$('div[data-hook]', this).each(function(index) {
						if($(this).data('hook') == 'text') {
							var currentEditorId = $(this).find('.tinymce').attr('id');							
							hook_section.push(tinyMCE.get(currentEditorId).getContent());
						}
						else {
							var val = $(this).find('input[name="img"], input[name="video"]').val();
							hook_section.push(val);
							//hook_section.push($(this).val());
						}
					});

					hook[i] = hook_section;
				}

				if($(this).data('type') == 'text') {
					var currentEditorId = $(this).find('.tinymce').attr('id');
					var val = tinyMCE.get(currentEditorId).getContent();
				}
				else {
					var val = $(this).find('input[type="text"], input[type="search"], input[type="hidden"]').val();
					console.log('hidden'+val);
				}
				val_section[j] = val;
				content[i] = val_section;
				j++;
			});

			i++;
		});
		if( $('#Id_page_content').length > 0 ){
			var Id_page_content = $('#Id_page_content').val();
		} else {
			var Id_page_content = "none";
		}
		$.post(path+'request/xhr/content/add_section.php', { 
			page: page, 
			lang: lang, 
			menu_title: menu_title,
			admin_title: admin_title,
			banner_title: banner_title,
			banner_link: banner_link,
			show: show, 
			menu: menu, 
			menu_id: menu_id, 
			type: type, 
			structure: structure, 
			content: content, 
			hook: hook,
			fluid: fluid,
			add_class: add_class,
			secure_login: secure_login,
			secure: secure,
			Id_page_content: Id_page_content,
			token: token
		}, function(response) {
			if(response.action=='success') {
				toastr.success(response.msg);
			}
			else if(response.action == 'token' || response.token === null) {
				location.reload();
			}			
			else {
				toastr.error(response.msg);
			}
		}, 'json');

		e.preventDefault();
	});

    // save template et contenu
    $(document).on('click', '#save-content', function(e) {
    	var page = $('input[name=page]').val();	
    	var lang = $('input[name=lang]').val();
    	var menu_title = $('input[name=menu_title]').val();
    	var admin_title = $('input[name=admin_title]').val();
		var banner_title = $('input[name=banner_title]').val();
		var banner_link = $('select[name=banner_link]').val();

    	if($("#Online_page").is(':checked')) {
    		var show = 1;
    	}
    	else {
    		var show = 0;
    	}

    	if($("#secure_login").is(':checked')) {
    		var secure_login = 1;
    	}
    	else {
    		var secure_login = 0;
    	}	

    	if($("#secure").is(':checked')) {
    		var secure = 1;
    	}
    	else {
    		var secure = 0;
    	}	

    	if($("#Menu_visible").is(':checked')) {
    		var menu = 1;
    	}
    	else {
    		var menu = 0;
    	}

    	var menu_id = $('#Menu_id').val();	

    	var structure = [];
    	var content = [];
    	var type = [];
    	var val = [];
    	var hook = [];
    	var fluid = [];
    	var add_class = [];
    	var i = 0;
    	
    	$('#section_target section').each(function() {
    		structure[i] = $(this).attr('id').split('_')[1];

	 		// gestion class fluid
	 		if($(this).find('.control').hasClass('class_fluid')) {
	 			fluid[i] = 1;
	 		}
	 		else {
	 			fluid[i] = 0;
	 		}

	 		// ajout de class/id
	 		if($(this).find('.control').attr('rel') !== undefined) {
	 			add_class[i] = $(this).find('.control').attr('rel');
	 		}
	 		else {
	 			add_class[i] = 'null';	 		
	 		}

	 		console.log(add_class[i]);
	 		
	 		var type_section = [];
	 		var val_section = [];
	 		var j = 0;
	 		$('div[data-type]', this).each(function() {
	 			type_section[j] = $(this).data('type');
	 			type[i] = type_section;

	 			if($(this).data('type') == 'code') {
	 				var $this = $(this);
	 				var hook_section = [];

	 				$('div[data-hook]', this).each(function(index) {
	 					if($(this).data('hook') == 'text') {
	 						var currentEditorId = $(this).find('.tinymce').attr('id');							
	 						hook_section.push(tinyMCE.get(currentEditorId).getContent());
	 					}
	 					else {
	 						var val = $(this).find('input[name="img"], input[name="video"]').val();
	 						hook_section.push(val);
	 					}
	 				});

	 				hook[i] = hook_section;
	 			}

	 			if($(this).data('type') == 'text') {
	 				var currentEditorId = $(this).find('.tinymce').attr('id');
	 				var val = tinyMCE.get(currentEditorId).getContent();
	 			}
	 			else {
	 				var val = $(this).find('input[type="text"], input[type="hidden"]').val();
	 				console.log(val);
	 			}
	 			val_section[j] = val;
	 			content[i] = val_section;
	 			j++;
	 		});

	 		i++;
	 	});

    	$.post(path+'request/xhr/content/add_section.php', { 
    		page: page, 
    		lang: lang, 
    		menu_title: menu_title,
    		admin_title: admin_title,
			banner_title: banner_title,
			banner_link: banner_link,
    		show: show, 
    		menu: menu, 
    		menu_id: menu_id, 
    		type: type, 
    		structure: structure, 
    		content: content, 
    		hook: hook,
    		fluid: fluid,
    		add_class: add_class,
    		secure_login: secure_login,
    		secure: secure,
    		token: token
    	}, function(response) {
    		if(response.action=='success') {
    			toastr.success(response.msg);
    		}
    		else {
    			toastr.error(response.msg);
    		}
    	}, 'json');

    	e.preventDefault();
    });

	// save template et contenu
	$(document).on('click', '.delete-section', function(e) {
		$(this).closest('section').remove();
		e.preventDefault();
	});


	// ajouter une nouvelle page
	$(document).on('click', '#add-content', function(e) {
		var lang = $('html').attr('lang');
		var data = $('#add-content-form').serializeArray();
		data[data.length] = { name: 'token', value: token };

		$.getJSON(path+'request/xhr/content/add_content.php', data, function(response) {

			if(response.action=='success') {
				toastr.success(response.msg);
				document.location.href =  path+lang+'/website/content/update/'+response.id;
			}
			else if(response.action=='empty') {
				toastr.warning(response.msg);
			}
			else if(response.action == 'token' || response.token === null) {
				location.reload();
			}            
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
	});

	$('select[name=reload_version]').change(function() {
		var Id_page_content = $(this).val();
		var lang = $('input[name=Lng]').val();
		$('#previewBackup').html('<a href="/'+lang+'?Id_page_content='+Id_page_content+'&preview" target="_blank" class="float-right"><i class="fas fa-desktop url_content"></i></a>');
		$('#Id_page_content').val(Id_page_content);
		$.post(path+'request/xhr/content/reload.php', { 'Id_page_content' : $(this).val(), 'Lng' : $('input[name=Lng]').val() }, function(response) {
			$('#section_target').html(response);
			tinymce.init({
				selector: '.tinymce',
				plugins: "autoresize link lists advlist code help",
				autoresize_bottom_margin: 20,
				branding: false,
				menubar:false,
				statusbar: false,
				toolbar: "undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | link code",
				color_map: [
				"555D65", "Black",
				"E2001A", "Red",
				"89D221", "Green",
				"00254D", "Blue",
				"9ABCE1", "LightBlue"
				]
			});
		});
	});

	$(document).on('change', 'input[name=video]', function(e) {
		var $this = $(this);
		var val = $(this).val();
		$.get(path+'template/section/template/video.php', function(response) {
			$this.closest('[data-type]').find('.preview').html(response.replace('[src]', val));
		});
	});

	$(document).on('change', 'input[name=code]', function(e) {
		var $this = $(this);
		var hook = $(this).val();
		$.get(path+'template/section/template/code.php', {hook: hook}, function(response) {
			$this.closest('[data-type]').find('.preview').html(response);

			tinymce.init({
				selector: '.tinymce',
				plugins: "autoresize link lists advlist code",
				autoresize_bottom_margin: 20,
				branding: false,
				menubar:false,
				statusbar: false,
				toolbar: "formatselect | undo redo | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist | removeformat code help"
			});
		});
	});

	// sortable catégories
	if($('body').find('#section_target section').length>0) {
		$('#section_target').sortable({
			axis: 'y',
			start: function (e, ui) {
				$(ui.item).find('textarea').each(function () {
					tinymce.execCommand('mceRemoveEditor', false, $(this).attr('id'));
				});
			},
			stop: function (e, ui) {
				$(ui.item).find('textarea').each(function () {
					tinymce.execCommand('mceAddEditor', true, $(this).attr('id'));
				});
			}
		});
	}

	// sortable catégories
	if($('body').find('.preview [data-hook]').length>0) {
		$('.preview').sortable({
			axis: 'y',
			start: function (e, ui) {
				$(ui.item).find('textarea').each(function () {
					tinymce.execCommand('mceRemoveEditor', false, $(this).attr('id'));
				});
			},
			stop: function (e, ui) {
				$(ui.item).find('textarea').each(function () {
					tinymce.execCommand('mceAddEditor', true, $(this).attr('id'));
				});
			}
		});
	}


	// mettre une page en ligne ou hors ligne
	$(document).on('click', '#sync-page', function(e) {
		var id = $(this).data('id');
		var lang = $(this).data('lang');
		$.getJSON(path+'request/xhr/content/sync-page.php', {id: id, lang: lang, token: token }, function(response) {

			if(response.action=='success') {
				toastr.success(response.msg);
				location.reload();
			}
			else if(response.action=='empty') {
				toastr.warning(response.msg);
			}
			else if(response.action == 'token' || response.token === null) {
				location.reload();
			}    
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
	});	

	$(document).on('click', '.add-keyword', function(e) {
		$('#form-save-keyword input[type="text"]').val('');
		$('#form-save-keyword #id_keyword').attr('readonly', false).removeClass('form-control-solid');
		$('#modal-keyword').modal('show'); 
		e.preventDefault();
	});

	$(document).on('keydown keyup change', '.uppercaser', function(e) {
		$(this).val($(this).val().toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\p{Diacritic}/gu, "").replace(/\s+/g, "_").replace(/[^\w\s\']|_/g, "_").replace('___', '_').replace('__', '_').replace(/^_+/, ''));
	});

	$(document).on('click', '.update-keyword', function(e) {
		var id = $(this).data('id');

		$.getJSON(path+'request/xhr/keyword/get-keyword.php', {id:id, token: token }, function(response) {
			if(response.action == 'success') {
				$('#form-save-keyword input[type="text"]').val('');
				$('#form-save-keyword #id_keyword').val(id);

				$('#form-save-keyword #id_keyword').attr('readonly', true).addClass('form-control-solid');

				$.each(response.keywords, function(key, value) {
					$('#form-save-keyword input[name="' + key + '"]:not(#public').val(value);
				});

				if(response.keywords.public == 1) {	
					$('#form-save-keyword #public').prop('checked', true);
				}
				else {
					$('#form-save-keyword #public').prop('checked', false);
				}

				$('#modal-keyword').modal('show'); 
			}
			else if(response.action == 'empty') {
				toastr.warning(response.msg);
			}
			else if(response.action == 'token' || response.token === null) {
				location.reload();
			}
			else {
				toastr.error(response.msg);
			}
		});
		e.preventDefault();
	});

	$( function() {
    	$('#sort-quote-product').sortable({ handle: '.drag-product' });
  	});


	$(document).on('click', '.add-keys', function(e) {
		$('#form-save-keys input').val('');
		$('#form-save-keys #key-name').attr('readonly', false).removeClass('form-control-solid');
		$('#modal-keys').modal('show'); 
		e.preventDefault();
	});


	$(document).on('click', '.update-keys', function(e) {
		var id = $(this).closest('[data-id]').data('id');

		$.getJSON(path+'request/xhr/settings/get-keys.php', {id:id, token: token }, function(response) {
			if(response.action == 'success') {
				$('#form-save-keys input[type="text"]').val('');
				$('#form-save-keys #id').val(id);

				$('#form-save-keys #key-name').attr('readonly', true).addClass('form-control-solid');
				$('#form-save-keys #key-name').val(response.keys.name);
				$('#form-save-keys #dev').val(response.keys.dev);
				$('#form-save-keys #prod').val(response.keys.prod);
				if(response.keys.public == 1) {					
					$('#form-save-keys #public').prop('checked', true);
				}
				else {
					$('#form-save-keys #public').prop('checked', false);
				}
				

				$('#modal-keys').modal('show'); 
			}
			else if(response.action == 'empty') {
				toastr.warning(response.msg);
			}
			else if(response.action == 'token' || response.token === null) {
				location.reload();
			}
			else {
				toastr.error(response.msg);
			}
		});
		e.preventDefault();
	});

	$(document).on('submit', '#update-meta-form', function(e) {
		var lang = $('html').attr('lang');
		var data = $(this).serializeArray();
		data[data.length] = { name: 'token', value: token };

		$.getJSON(path+'request/xhr/content/meta.php', data, function(response) {

			if(response.action=='success') {
				toastr.success(response.msg);
			}
			else if(response.action=='empty') {
				toastr.warning(response.msg);
			}
			else if(response.action == 'token' || response.token === null) {
				location.reload();
			}    
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
	});

	$(document).on('click','.log-show', function(e){
		var id = $(this).data('id');

		$.getJSON(path+'request/xhr/logs/get-logs.php', {id:id, token: token}, function(response){
			if (response.action == 'success') {
				$('#modal_log').modal('show');
				$('#modal_log .modal-title').html(response.title);
				$('#modal_log .modal-body').html(response.html);
			}
		});
	});

	$(document).on('click','.get-logs-errors', function(e){
		e.preventDefault();

		var id = $(this).closest('[data-id]').data('id');

		$.getJSON(path+'request/xhr/settings/get-logs-errors.php', {id:id, token: token}, function(response){
			if (response.action == 'success') {
				$('#modal-logs-errors').modal('show');
				$('#modal-logs-errors .modal-title').html(response.title);
				$('#modal-logs-errors .modal-body').html(response.html);
			}
		});
	});

	$(document).on('click', '.get-file', function(e){
		e.preventDefault();
		var id = $(this).data('id');

		$.getJSON(path+'request/xhr/files/get-file.php', {id:id, token: token}, function(response){
			if (response.action == 'success') {
				$('#modal-update-file').modal('show');
				$('#modal-update-file .modal-title span').html(response.file.filename);

				var form = '#modal-update-file #form-update-file';
				$(form).find('input').val('');

				$.each(response.file, function(i, item) {
					if($(form).find('#'+i).prop('tagName') == 'INPUT') {
				    	$(form).find('#'+i).val(item);
				    }
				    else {
						$(form).find('#'+i).text(item);
				    }
				});
				// $('#modal-update-file #form-update-file #filename').val(response.file.name);
				// $('#modal-update-file #form-update-file #link').val(response.file.link);
				// $('#modal-update-file #form-update-file #size').html(response.file.size);
				// $('#modal-update-file #form-update-file #updated-at').html(response.file.updated_at);
				// $('#modal-update-file #form-update-file #id').html(response.file.id);

				$('#modal-update-file #alt').addClass('d-none');
				$('#modal-update-file #dimension').addClass('d-none');

				if(response.file.type == 'image') {
					$('#modal-update-file #alt').removeClass('d-none');
					$('#modal-update-file #dimension').removeClass('d-none');
					$('#modal-update-file #preview').html('<img src="/dist/assets/'+response.file.path+response.file.filename+'" class="mh-100 mw-100">');
				}
				else if(response.file.type == 'video') {
					$('#modal-update-file #preview').html('<i class="fa-duotone fa-clapperboard-play fa-2xl text-primary"></i>');
				}
				else {
					$('#modal-update-file #preview').html('<i class="fa-duotone fa-file fa-2xl text-primary"></i>');
				}
			}
		});
	});

	$(document).on('click','[data-settings-users]', function(e){
		var id = $(this).closest('[data-id]').data('id');
		var type = $(this).data('settings-users');

		var access;
		if($(this).is(':checked')) {
			access = 1;
		}
		else {
			access = 0;
		}

		$.post(path+'request/xhr/settings/update-access.php', {id:id, access: access, type: type, token: token}, function(response){
			if(response.action=='success') {
				toastr.success(response.msg);
			}
			else if(response.action=='empty') {
				toastr.warning(response.msg);
			}
			else if(response.action == 'token' || response.token === null) {
				location.reload();
			}    
			else {
				toastr.error(response.msg);
			}
		}, 'json');
	});

	$(document).on('click','[data-settings-modules]', function(e){
		var id = $(this).closest('[data-id]').data('id');

		var access;
		if($(this).is(':checked')) {
			access = 1;
		}
		else {
			access = 0;
		}

		$.post(path+'request/xhr/settings/update-module.php', {id:id, access: access, token: token}, function(response){
			if(response.action=='success') {
				toastr.success(response.msg);
			}
			else if(response.action=='empty') {
				toastr.warning(response.msg);
			}
			else if(response.action == 'token' || response.token === null) {
				location.reload();
			}    
			else {
				toastr.error(response.msg);
			}
		}, 'json');
	});

	$(document).on('change','#lng-default', function(e){
		var id = $(this).val();

		$.post(path+'request/xhr/settings/update-default-language.php', {id:id, token: token}, function(response){
			if(response.action=='success') {
				toastr.success(response.msg);
			}
			else if(response.action=='empty') {
				toastr.warning(response.msg);
			}
			else if(response.action == 'token' || response.token === null) {
				location.reload();
			}    
			else {
				toastr.error(response.msg);
			}
		}, 'json');
	});

	$(document).on('click','[data-settings-languages]', function(e){
		var id = $(this).closest('[data-id]').data('id');

		var access;
		if($(this).is(':checked')) {
			access = 1;
		}
		else {
			access = 0;
		}

		$.post(path+'request/xhr/settings/update-language.php', {id:id, access: access, token: token}, function(response){
			if(response.action=='success') {
				toastr.success(response.msg);
			}
			else if(response.action=='empty') {
				toastr.warning(response.msg);
			}
			else if(response.action == 'token' || response.token === null) {
				location.reload();
			}    
			else {
				toastr.error(response.msg);
			}
		}, 'json');
	});

	$(document).on('click','.define a', function(e){
		e.preventDefault();
		var text = $(this).closest('td').find('span').text();
		
		if (location.protocol === 'https:') {
			navigator.clipboard.writeText(text).then(() => {	        
				toastr.success(text+' copied !');
		    });
		}
		else {
			toastr.error('Copy function doesn\'t work on non https protocol !');
		}
	});


	$(document).on('click','[data-copy]', function(e){
		e.preventDefault();
		var id = $(this).data('copy');

		if($('[data-copy-target='+id+']').prop('tagName') == 'INPUT') {
			var text = $('[data-copy-target='+id+']').val();
		}
		else {
			var text = $('[data-copy-target='+id+']').text();
		}
		
		
		if (location.protocol === 'https:') {
			navigator.clipboard.writeText(text).then(() => {	        
				toastr.success(text+' copied !');
		    });
		}
		else {
			toastr.error('Copy function doesn\'t work on non https protocol !');
		}
	});
	
	$(document).on('click','[data-mode]', function(e){
		e.preventDefault();
		var mode = $(this).data('mode');

		$('#preview').removeClass('light dark');
		$('#preview').addClass(mode);

		$('[data-mode]').removeClass('d-none');
		$('[data-mode='+mode+']').addClass('d-none');
	});

	// Format options
	var optionFormat = function(item) {
	    if ( !item.id ) {
	        return item.text;
	    }

	    var span = document.createElement('span');
	    var imgUrl = item.element.getAttribute('data-select2-from');
	    var template = '';

	    template += imgUrl;
	    template += item.text;

	    span.innerHTML = template;

	    return $(span);
	}

	// Init Select2 --- more info: https://select2.org/
	$('#modal-ticket #from').select2({
	    templateSelection: optionFormat,
	    templateResult: optionFormat
	});

	// Init Select2 --- more info: https://select2.org/
	/*$('#modal-sav #from').select2({
	    templateSelection: optionFormat,
	    templateResult: optionFormat
	});*/


	// Format options
	var optionFormat = function(item) {
	    if ( !item.id ) {
	        return item.text;
	    }

	    var span = document.createElement('span');
	    var imgUrl = item.element.getAttribute('data-select2-assign-to');
	    var template = '';

	    template += imgUrl;
	    template += item.text;

	    span.innerHTML = template;

	    return $(span);
	}

	// Init Select2 --- more info: https://select2.org/
	$('#assign-to').select2({
	    templateSelection: optionFormat,
	    templateResult: optionFormat
	});

	$('#modal-ticket').on('hidden.bs.modal', function (e) {
		$('#modal-ticket .ticket-nbr').html('');
		$('#modal-ticket').find('input, select, textarea').val('');
		$('#modal-ticket input[type=checkbox]').prop('checked', false);
		$('#modal-ticket #ticket-status').val('10');
		$('#modal-ticket [data-control="select2"]').trigger('change.select2'); 
	});

	$('#modal-sav').on('hidden.bs.modal', function (e) {
		$('#modal-sav .sav-nbr').html('');
		$('#modal-sav').find('input, select, textarea').val('');
		$('#modal-sav input[type=checkbox]').prop('checked', false);
		$('#modal-sav #sav-status').val('10');
		$('#modal-sav [data-control="select2"]').trigger('change.select2'); 
	});



	if($('#opportunity-kanban').length > 0) {
		var dev = $('[data-dev]').data('dev');

		$.post(path+'request/xhr/opportunity/get-kanban-opportunity.php', { token: token, dev: dev}, function(response){

			var kanban = new jKanban({
			    element: '#opportunity-kanban',
			    gutter: '0',
	            widthBoard: '20%',                                     // width of the board
    			responsivePercentage: true, 
	            dragBoards: false,
			    click: function(el) {
			    },
			    dropEl: function(el, target, source, sibling){
					var from = source.parentElement.getAttribute('data-id');
					var to = target.parentElement.getAttribute('data-id');
					var card = el.getAttribute('data-eid');
					var ordering = [];

					$('[data-eid]').each(function() {
                        ordering.push($(this).data('eid'));
					});

		          	$.post(path+'request/xhr/opportunity/move-card.php', { token: token, card: card, from: from, to: to, ordering: ordering }, function(response){

						if(response.action == 'success') {
							toastr.success(response.msg);
							/*$('#search-result-box').html(response.html);

							if($('#opportunity-chart').length > 0) {
								// progress bar
								get_offer_progress(token, job);
							}*/

						}
						else if(response.action == 'empty') {
				    		toastr.warning(response.msg);
						}
						else if(response.action == 'token' || response.token === null) {	
				    		toastr.danger(response.msg);
							location.reload();
						}
						else {	
				    		toastr.danger(response.msg);
						}
					}, 'json');
		        },
			    boards: response.kanban.boards
			});
		}, 'json');

		$(document).on('click', '.kanban-link', function(e) {
			location.href = $(this).attr('href');
		});
	}


	
		
	if($('#opportunity').length > 0) {
		$('#opportunity').easyAutocomplete({
			url: function(phrase) {
				return path+'request/xhr/opportunity/get-opportunity.php?token='+token;
			},

			getValue: 'name',

			template: {
				type: "custom",
				method: function(value, item) {
					var output = value.split(' ');
					var id = output[0];
					var name = value.replace(id+' ', '');
					return '<span class="text-gray-600 fw-semibold me-3">'+id+'</span>'+ name;
				}
			},

			list: {
				maxNumberOfElements: 8,
				match: {
					enabled: true
				},
				onClickEvent: function() {
					var id = $('#opportunity').getSelectedItemData().id;
					// var price = $('#opportunity').getSelectedItemData().price;
					// var vat = $('#opportunity').getSelectedItemData().vat;

					$('#id-opportunity').val(id);
					// $('#opportunity').closest('tr').find('[data-kt-element="price"]').val(price);
					// $('#opportunity').closest('tr').find('[data-kt-element="vat"]').val(vat);

					// xhr_send('contact/get-address', token, null);
					$.getJSON(path+'request/xhr/contact/get-address.php', { token: token, id: id }, function(response) {
						$('#site-address, #billing-address').html(response.output)
					});
				}
			},

			ajaxSettings: {
				dataType: "json",
				method: "POST",
				data: {
			  		dataType: "json"
				}
			},

			preparePostData: function(data) {
				data.phrase = $(".get-opportunity").val();
				return data;
			},
			adjustWidth: false,
			requestDelay: 300
		});
	}

	if($('#form-add-invoice-deposit').length > 0) {
		$('#quote').easyAutocomplete({
			url: function(phrase) {
				return path+'request/xhr/quote/get-quote.php?token='+token;
			},

			getValue: 'name',

			template: {
				type: "custom",
				method: function(value, item) {
					var output = value.split(' ');
					var id = output[0];
					var name = value.replace(id+' ', '');
					return '<span class="text-gray-600 fw-semibold me-3">'+id+'</span>'+ name;
				}
			},

			list: {
				maxNumberOfElements: 8,
				match: {
					enabled: true
				},
				onClickEvent: function() {
					var id = $('#quote').getSelectedItemData().id;
					// var price = $('#quote').getSelectedItemData().price;
					// var vat = $('#quote').getSelectedItemData().vat;

					$('#id-quote').val(id);
					// $('#quote').closest('tr').find('[data-kt-element="price"]').val(price);
					// $('#quote').closest('tr').find('[data-kt-element="vat"]').val(vat);

					// xhr_send('contact/get-address', token, null);
					$.getJSON(path+'request/xhr/contact/get-address.php', { token: token, id: id }, function(response) {
						$('#site-address, #billing-address').html(response.output)
					});
				}
			},

			ajaxSettings: {
				dataType: "json",
				method: "POST",
				data: {
			  		dataType: "json"
				}
			},

			preparePostData: function(data) {
				data.phrase = $(".get-quote").val();
				return data;
			},
			adjustWidth: false,
			requestDelay: 300
		});
	}

	if($('#product-pricing input, #product-pricing input').length > 0) {
		function price_ttc() {
			var price = parseFloat($('#price').val());
			var margin = parseInt($('#margin').val());

			var price_htva = price + price * margin / 100;
			var price_wc_margin = ((price / wc) + (price_wc * margin / 100));

			$('#price-ttc').html(price_htva.toFixed(2));
		}

		price_ttc();

		$(document).on('change', '#product-pricing input,#product-pricing input', function(e) {
			price_ttc();	
		});
	}
	

	"use strict";


	if($('#kt_docs_fullcalendar_selectable').length > 0) {

        $.getJSON(path+'request/xhr/calendar/calendar.php', { token: token }, function(response) {
			var calendarEl = document.getElementById("kt_docs_fullcalendar_selectable");

			var calendar = new FullCalendar.Calendar(calendarEl, {
			    headerToolbar: {
			        left: "prev,next today",
			        center: "title",
			        right: "dayGridMonth,timeGridWeek,timeGridDay"
			    },
			    // initialDate: "2020-09-12",
			    navLinks: true, // can click day/week names to navigate views
			    selectable: true,
			    selectMirror: true,
			    locale: 'fr',

			    // Create new event
			    select: function (arg) {
			        Swal.fire({
			            html: `<div class="mb-7">Create new event?</div><div class="fw-bold mb-5">Event Name:</div><input type="text" class="form-control" name="event_name" />`,
			            icon: "info",
			            showCancelButton: true,
			            buttonsStyling: false,
			            confirmButtonText: "Yes, create it!",
			            cancelButtonText: "No, return",
			            customClass: {
			                confirmButton: "btn btn-primary",
			                cancelButton: "btn btn-active-light"
			            }
			        }).then(function (result) {
			            if (result.value) {
			                var title = document.querySelector(`input[name="event_name"]`).value;
			                if (title) {
			                    calendar.addEvent({
			                        title: title,
			                        start: arg.start,
			                        end: arg.end,
			                        allDay: arg.allDay
			                    })
			                }
			                calendar.unselect()
			            } else if (result.dismiss === "cancel") {
			                Swal.fire({
			                    text: "Event creation was declined!.",
			                    icon: "error",
			                    buttonsStyling: false,
			                    confirmButtonText: "Ok, got it!",
			                    customClass: {
			                        confirmButton: "btn btn-primary",
			                    }
			                });
			            }
			        });
			    },

			    // Delete event
			    eventClick: function (arg) {
			        Swal.fire({
			            text: "Are you sure you want to delete this event?",
			            icon: "warning",
			            showCancelButton: true,
			            buttonsStyling: false,
			            confirmButtonText: "Yes, delete it!",
			            cancelButtonText: "No, return",
			            customClass: {
			                confirmButton: "btn btn-primary",
			                cancelButton: "btn btn-active-light"
			            }
			        }).then(function (result) {
			            if (result.value) {
			                arg.event.remove()
			            } else if (result.dismiss === "cancel") {
			                Swal.fire({
			                    text: "Event was not deleted!.",
			                    icon: "error",
			                    buttonsStyling: false,
			                    confirmButtonText: "Ok, got it!",
			                    customClass: {
			                        confirmButton: "btn btn-primary",
			                    }
			                });
			            }
			        });
			    },
			    editable: true,
			    dayMaxEvents: true, // allow "more" link when too many events
			    events: response.calendar,
			    initialView: 'timeGridWeek',
			    slotMinTime: '06:00:00',
			    slotMaxTime: '20:00:00',
			    handleWindowResize: true,
			    eventContent: function (arg) {
					            var event = arg.event;         
					            var customHtml = ''; 
					            customHtml += '<div class="d-flex flex-row custom-event">';
					            if(event.extendedProps.users !== undefined) { 
					            	customHtml += event.extendedProps.users; 
				            	}         
					            customHtml += "<span class='r10 font-xxs font-bold' style='overflow: hidden;'>" + event.title + "</span>";                      

					            customHtml += '</div>';
					            return { html: customHtml }
					        }
			});

			calendar.render();
		});
	}

	if($('#home-ca-chart').length > 0) {
		
		var chart = $('#home-ca-chart').data('chart');

		$.getJSON(path+'request/xhr/home/get-home-ca.php', {token: token, chart: chart }, function(response) {

			if(response.action=='success') {

				var options = {
						series: [{
							name: 'Objectifs',
							type: 'area',
							data: response.target
						}, {
							name: `Chiffre d'affaire`,
							type: 'column',
							data: response.ca
						}],
						chart: {
							toolbar: {
        						show: false,
        					},
							height: 600,
							type: 'line',
          					stacked: false
						},
						colors:['#0095E8', response.color],
						dataLabels: {
							enabled: false
						},
						stroke: {
							curve: 'smooth',	
						    width: [0, 2],
						},
				        plotOptions: {
				          bar: {
				            columnWidth: '50%'
				          }
				        },        
						fill: {
							opacity: [0.15, 1],
							gradient: {
								inverseColors: false,
								shade: 'light',
								type: "vertical",
								opacityFrom: 0.15,
								opacityTo: 1,
								stops: [0, 100]
							}
						},
						xaxis: {
							type: 'text',
							categories: response.category
						},
						yaxis: {
							labels: {
								formatter: function (value) {
									return commaSeparateNumber(value) + " €";
								}
							}
						},
						tooltip: {
							x: {
								// format: 'dd/MM/yy HH:mm'
							},
						},
					};

			    var chart = new ApexCharts(document.getElementById("home-ca-chart"), options);
			    chart.render();
			}
			else if(response.action=='empty') {
				toastr.warning(response.msg);
			}
			else if(response.action == 'token' || response.token === null) {
				location.reload();
			}            
			else {
				toastr.error(response.msg);
			}
		});
 		
	}

	if($('#stock-chart').length > 0) {
		
		var chart = $('#stock-chart').data('chart');

		$.getJSON(path+'request/xhr/stock/get-stock.php', {token: token, chart: chart }, function(response) {

			if(response.action=='success') {

				 var options = {
						series: response.series

						/* [
							{
								name: "High - 2013",
								data: [28, 29, 33, 36, 32, 32, 33]
							},
							{
								name: "Low - 2013",
								data: [12, 11, 14, 18, 17, 13, 13]
							},
							{
								name: "Low - 2013",
								data: [15, -11, 1, 8, 7, 3, 3]
							}
						]*/
				 		,

						chart: {
							height: 500,
							type: 'line',
							dropShadow: {
								enabled: true,
								color: '#000',
								top: 18,
								left: 7,
								blur: 10,
								opacity: 0.2
							},
							toolbar: {
								show: false
							}
						},
				        annotations: {
				            yaxis: [
				                {
				                    y: 0,
				                    borderColor: '#F00',
				                    label: {
				                        borderColor: '#F00',
				                        style: {
				                            color: '#fff',
				                            background: '#f00'
				                        },
				                        text: 'Stock'
				                    }
				                }
				            ]
				        },
						colors: ['#77B6EA', '#545454','#985945','#281618'],
						dataLabels: {
							enabled: false,
						},
						stroke: {
							curve: 'smooth'
						},
						title: {
							text: 'Average High & Low Temperature',
							align: 'left'
						},
						grid: {
							borderColor: '#e7e7e7',
							/*row: {
								colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
								opacity: 0.5
							},*/
						},
						markers: {
							size: 1
						},
						xaxis: {
							categories: response.xaxis,
							title: {
								text: ''
							}
						},
						yaxis: {
							title: {
								text: 'Solar panel'
							},
							// min: 5,
							// max: 40
						},
						legend: {
							position: 'top',
							horizontalAlign: 'right',
							floating: true,
							offsetY: -25,
							offsetX: -5
						}
					};

			    var chart = new ApexCharts(document.getElementById("stock-chart"), options);
			    chart.render();
			}
			else if(response.action=='empty') {
				toastr.warning(response.msg);
			}
			else if(response.action == 'token' || response.token === null) {
				location.reload();
			}            
			else {
				toastr.error(response.msg);
			}
		});
 		
	}

	if($('#modal-action[data-active="true"]').length > 0) {
		$('#modal-action').modal('show')
	}

	$(document).on('click', '[data-block]', function(e) {
		if($(this).find('input[type="checkbox"]').is(':checked')) {
			$(this).removeClass('locked');
		}
		else {
			$(this).addClass('locked');
		}
	});

/*var element = document.getElementById('kt_apexcharts_5');

var height = parseInt(KTUtil.css(element, 'height'));
var labelColor = '#A1A5B7';
var borderColor = '#EFF2F5';

var baseColor = '#009EF7';
var baseLightColor = '#F1FAFF';
var secondaryColor = '#5014D0';

if (!element) {
    return;
}

var options = {
    series: [{
        name: 'Net Profit',
        type: 'bar',
        stacked: true,
        data: [22472, 58187, 24015, 70, 50, 30]
    }, {
        name: 'Expenses',
        type: 'area',
        data: [50, 80, 60, 90, 50, 70]
    }],
    chart: {
        fontFamily: 'inherit',
        stacked: true,
        height: height,
        toolbar: {
            show: false
        }
    },
    plotOptions: {
        bar: {
            stacked: true,
            horizontal: false,
            endingShape: 'rounded',
            columnWidth: ['12%']
        },
    },
    legend: {
        show: false
    },
    dataLabels: {
        enabled: false
    },
    stroke: {
        curve: 'smooth',
        show: true,
        width: 2,
        colors: ['transparent']
    },
    xaxis: {
        categories: ['Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false
        },
        labels: {
            style: {
                colors: labelColor,
                fontSize: '12px'
            }
        }
    },
    yaxis: {
        max: 120,
        labels: {
            style: {
                colors: labelColor,
                fontSize: '12px'
            }
        }
    },
    fill: {
        opacity: 1
    },
    states: {
        normal: {
            filter: {
                type: 'none',
                value: 0
            }
        },
        hover: {
            filter: {
                type: 'none',
                value: 0
            }
        },
        active: {
            allowMultipleDataPointsSelection: false,
            filter: {
                type: 'none',
                value: 0
            }
        }
    },
    tooltip: {
        style: {
            fontSize: '12px'
        },
        y: {
            formatter: function (val) {
                return '$' + val + ' thousands'
            }
        }
    },
    colors: [baseColor, baseLightColor],
    grid: {
        borderColor: borderColor,
        strokeDashArray: 4,
        yaxis: {
            lines: {
                show: true
            }
        },
        padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }
    }
};

var chart = new ApexCharts(element, options);
chart.render();*/



	// Class definition
	if($('.data-table').length > 0) {
		var KTDatatablesButtons = function () {
		    // Shared variables
		    var table;
		    var datatable;

		    // Private functions
		    var initDatatable = function () {
		        // Set date data order
		        const tableRows = table.querySelectorAll('tbody tr');

		        tableRows.forEach(row => {
		            const dateRow = row.querySelectorAll('td');
		        });

		        // Init datatable --- more info on datatables: https://datatables.net/manual/
		        if($('[data-table-order]').length > 0) {
			        datatable = $(table).DataTable({
			            "info": false,
			            'pageLength': 50,
			            rowReorder: true,
			        });

			        datatable.on( 'row-reorder', function ( e, diff, edit ) {

				        var order_arr = new Array;
				        var order_db = $('[data-table-order]').data('table-order');

				        $('[data-table-order] tbody tr').each(function() {
				        	order_arr.push($(this).data('id'));
				        });

				        $.post('../request/xhr/'+order_db+'/order.php', {order_arr: order_arr, token: token}, function(response) {
				        	// location.reload();
				        }, 'json');
				    });
			    }
			    else {
			    	datatable = $(table).DataTable({
			            "info": false,
			            'order': [],
			            'pageLength': 50,
			            ordering: true,
			           "aaSorting": []
			        });
			    }
		    }

		    // Hook export buttons
		    var exportButtons = () => {
		        const documentTitle = 'Customer Orders Report';
		        var buttons = new $.fn.dataTable.Buttons(table, {
		            buttons: [
		                {
		                    extend: 'copyHtml5',
		                    title: documentTitle
		                },
		                {
		                    extend: 'excelHtml5',
		                    title: documentTitle
		                },
		                {
		                    extend: 'csvHtml5',
		                    title: documentTitle
		                },
		                {
		                    extend: 'pdfHtml5',
		                    title: documentTitle
		                }
		            ]
		        }).container().appendTo($('#datatable-export'));

		        // Hook dropdown menu click event to datatable export buttons
		        const exportButtons = document.querySelectorAll('#datatable-export-menu [data-kt-export]');
		        exportButtons.forEach(exportButton => {
		            exportButton.addEventListener('click', e => {
		                e.preventDefault();

		                // Get clicked export value
		                const exportValue = e.target.getAttribute('data-kt-export');
		                const target = document.querySelector('.dt-buttons .buttons-' + exportValue);

		                // Trigger click event on hidden datatable export buttons
		                target.click();
		            });
		        });
		    }

		    // Search Datatable --- official docs reference: https://datatables.net/reference/api/search()
		     var handleSearchDatatable = () => {
		        const filterSearch = document.querySelector('[data-kt-filter]');
		        const preFilterSearch = $('[data-kt-filter]').data('kt-filter');
		        if(preFilterSearch != '') {
		        	datatable.search(preFilterSearch).draw();
		        	$('[data-kt-filter]').val(preFilterSearch);
		        }

		        filterSearch.addEventListener('keyup', function (e) {
		            datatable.search(e.target.value).draw();
		        });
		    }

		    // Public methods
		    return {
		        init: function () {
		            table = document.querySelector('.data-table');

		            if ( !table ) {
		                return;
		            }

		            initDatatable();
		            exportButtons();
		            handleSearchDatatable();
		        }
		    };
		}();

		// On document ready
		KTUtil.onDOMContentLoaded(function () {
		    KTDatatablesButtons.init();
		});
	}

	if($('#quote-chart').length > 0) {

		var ctx = document.getElementById('quote-chart');

		// Define colors
		var primaryColor = '#009EF7';
		// var primaryColor ='#8dd00e';

		// Define fonts
		var fontFamily = KTUtil.getCssVariableValue('--bs-font-sans-serif');

		// Chart labels
		const labels = ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jui', 'Juil', 'Aou', 'Sep', 'Oct', 'Nov', 'Dec'];

		// Chart data
		const data = {
		    labels: labels,
		    datasets: [{
				data: [],
				borderWidth: 1,
				backgroundColor: primaryColor,
				label: 'Prod : ',
    		}]
		};

		// Chart config
		const config = {
		    type: 'bar',
		    data: data,
		    options: {
		        plugins: {
		            title: {
		                display: false,
		            },

				    legend: {
				        display: false
				    }
		        },
		        responsive: true,
		        interaction: {
		            intersect: false,
		        },
		        scales: {
		            x: {
		            	display: false
		            },
		            y: { 
		            	ticks: {
			                font: {
			                    size: 11,
			                }
			            }
		            }
		        }
		    },
		    defaults:{
		        global: {
		            // defaultFont: fontFamily
		        }
		    },
		    plugins: [{
		        id: 'custom_canvas_background_color',
				beforeDraw: (chart) => {
					const ctx = chart.canvas.getContext('2d');
					ctx.save();
					ctx.globalCompositeOperation = 'destination-over';
					ctx.fillStyle = 'white';
					ctx.fillRect(0, 0, chart.canvas.width, chart.canvas.height);
					ctx.restore();
				}
			}]
		};

		// Init ChartJS -- for more info, please visit: https://www.chartjs.org/docs/latest/
		var myChart = new Chart(ctx, config);


		var export_ctx = document.getElementById('export-chart');


		// Chart data
		const export_data = {
		    labels: labels,
		    datasets: [{
				data: [],
				borderWidth: 1,
				backgroundColor: '#8dd00e',
				label: 'Prod : ',
    		}]
		};

		// Chart config
		const export_config = {
		    type: 'bar',
		    data: export_data,
		    options: {
		    	animation: false,
		        plugins: {
		            title: {
		                display: false,
		            },

				    legend: {
				        display: false
				    }
		        },
		        responsive: false,
		        interaction: {
		            intersect: false,
		        },
		        scales: {
		            x: {
		            	ticks: {
			                font: {
			                    size: 12,
			                }
			            }
		            },
		            y: { 
				      	title: {
			        		display: true,
					        text: 'Production (kWh)',
					        font: {
					            size: 10,
				          	}
				      	},
		            	ticks: {
			                font: {
			                    size: 12,
			                }
			            }
		            }
		        }
		    },
		    defaults:{
		        global: {
		            // defaultFont: fontFamily
		        }
		    },
		    plugins: [{
		        id: 'custom_canvas_background_color',
				beforeDraw: (chart) => {
					const export_ctx = chart.canvas.getContext('2d');
					export_ctx.save();
					export_ctx.globalCompositeOperation = 'destination-over';
					export_ctx.fillStyle = 'white';
					export_ctx.fillRect(0, 0, chart.canvas.width, chart.canvas.height);
					export_ctx.restore();
				}
			}]
		};

		// Init ChartJS -- for more info, please visit: https://www.chartjs.org/docs/latest/
		var exportChart = new Chart(export_ctx, export_config);

	}




	/*if($('#kt_dropzonejs_image').length > 0) {
		// set the dropzone container id
		const id = "#kt_dropzonejs_image";
		const dropzone = document.querySelector(id);

		// set the preview element template
		var previewNode = dropzone.querySelector(".dropzone-item");
		previewNode.id = "";
		var previewTemplate = previewNode.parentNode.innerHTML;
		previewNode.parentNode.removeChild(previewNode);


		var folder = $("#kt_dropzonejs_image").data('folder');
		var record = $("#kt_dropzonejs_image").data('record');
		var input = $("#kt_dropzonejs_image").data('input');


		var myDropzone = new Dropzone(id, { // Make the whole body a dropzone
		    url: path+'request/xhr/upload/upload.php?folder='+folder+'&record='+record+'&input='+input, // Set the url for your upload script location
		    acceptedFiles: 'image/*',
		    parallelUploads: 20,
		    maxFilesize: 8, // Max filesize in MB
		    previewTemplate: previewTemplate,
		    previewsContainer: id + " .dropzone-items", // Define the container to display the previews
		    clickable: id + " .dropzone-select" // Define the element that should be used as click trigger to select files.
		});

		myDropzone.on("addedfile", function (file) {
		    // Hookup the start button
		    const dropzoneItems = dropzone.querySelectorAll('.dropzone-item');
		    dropzoneItems.forEach(dropzoneItem => {
		        dropzoneItem.style.display = '';
		    });
		});

		// Update the total progress bar
		myDropzone.on("totaluploadprogress", function (progress) {
		    const progressBars = dropzone.querySelectorAll('.progress-bar');
		    progressBars.forEach(progressBar => {
		        progressBar.style.width = progress + "%";
		    });
		});

		myDropzone.on("sending", function (file) {
		    // Show the total progress bar when upload starts
		    const progressBars = dropzone.querySelectorAll('.progress-bar');
		    progressBars.forEach(progressBar => {
		        progressBar.style.opacity = "1";
		    });
		});

		// Hide the total progress bar when nothing"s uploading anymore
		myDropzone.on("complete", function (progress) {
		    const progressBars = dropzone.querySelectorAll('.dz-complete');

		    setTimeout(function () {
		        progressBars.forEach(progressBar => {
		            progressBar.querySelector('.progress-bar').style.opacity = "0";
		            progressBar.querySelector('.progress').style.opacity = "0";
		        });
		    }, 300);
		    console.log(progress);

		    if(progress.status == 'success') {    	
			    toastr.success('File uploaded')
			    setTimeout(function () {
			        location.reload();
			    }, 3000);
		    }
		    
		});
	}*/

function filemanager_dropzone(path, source) {
	var folder = $("#kt_dropzonejs_image").data('folder');
	var record = $("#kt_dropzonejs_image").data('record');
	var input = $("#kt_dropzonejs_image").data('input');

	var myDropzone = new Dropzone("#kt_dropzonejs_image", {
	    url: path+'request/xhr/upload/upload.php?folder='+folder+'&record='+record+'&input='+input, // Set the url for your upload script location
	    paramName: "file", // The name that will be used to transfer the file
	    maxFiles: 10,
	    maxFilesize: 200, // MB
	    addRemoveLinks: true,
	    success: function(file, response) {
			response = JSON.parse(response);
			
      		if($('#no-file-result').length > 0) {
      			$('#no-file-result').remove();
      		}

      		if(response.path === null) {
      			response.path = '';
      		}

      		var file = response.filename+'.'+response.ext;
      		var folder_url = encodeURI(response.path)+response.filename+'.'+response.ext;
      		var folder = response.path+response.filename+'.'+response.ext;

      		if(source == 'file-manager') {
      			var src = 'get-file';
      			var data_xhr = 'files/get-file';
      		}
      		else if(source == 'content-manager') {
      			var src = 'select-image';
      			var data_xhr = 'content/select-image';
      		}

      		var template = `<a href="" class="w-150px h-150px card shadow-sm overflow-hidden mt-5 me-5 ${src}" data-xhr="${data_xhr}" data-id="${folder}">
								    <div class="card-body flex-column align-items-center p-0 file-box">`;

	      	if(response.type == 'img') {

	      		var template = template + `<img src="/dist/assets/${folder}" class="img-fluid">`

	      	}
	      	else if(response.type == 'video') {
	      		var template = template + `<i class="fa-duotone fa-clapperboard-play fa-2xl text-primary"></i><span class="mt-3 text-center">${file}</span>`;
	      	}
	      	else {
	      		var template = template + `<i class="fa-duotone fa-file fa-2xl text-primary"></i><span class="mt-3 text-center">${file}</span>`;
	      	}

	      	template += `	</div>
						</a>`;


			$(template).prependTo('#file-result');
		}
	});
}

if($('#kt_dropzonejs_image').length > 0) {
	filemanager_dropzone(path, 'file-manager')
}

$(document).on('click', '#kt_app_technical_container .nav-link', function(e) {
	var id = $(this).attr('id').replace('-tab', '');

	window.history.replaceState(null, null, '?step='+id);
});




$(document).on('click', '.technical-link', function(e) {
	e.preventDefault();
	$('#technical-dropzone').removeClass('d-none');
	var selected_type = $(this).find('input').val();
	$('#technical-type').val(selected_type);
});

function technical_dropzone(path, zone, source) {
	var folder = $('[data-zone='+zone+']').data('folder');
	var record = $('[data-zone='+zone+']').data('record');
	var input = $('[data-zone='+zone+']').data('input');

	var myDropzone = new Dropzone('[data-zone='+zone+']', {
	    url: path+'request/xhr/upload/upload.php?folder='+folder+'&record='+record+'&input='+input, // Set the url for your upload script location
	    paramName: "file", // The name that will be used to transfer the file
	    maxFiles: 10,
	    maxFilesize: 200, // MB
	    addRemoveLinks: true,
	    capture: "image/*",
	    init: function() {
		    this.on("sending", function(file, xhr, formData) {
		       var value = $("#technical-type").val();
		       formData.append("type", value); // Append all the additional input data of your form here!
		    });
		},
	    success: function(file, response) {
			response = JSON.parse(response);
			
      		if($('#no-file-result').length > 0) {
      			$('#no-file-result').remove();
      		}

      		if(response.path === null) {
      			response.path = '';
      		}

      		var file = response.filename+'.'+response.ext;
      		var folder_url = encodeURI(response.path)+response.filename+'.'+response.ext;
      		var folder = response.path+response.filename+'.'+response.ext;

      		if(source == 'file-manager') {
      			var src = 'get-file';
      			var data_xhr = 'files/get-file';
      		}
      		else if(source == 'content-manager') {
      			var src = 'select-image';
      			var data_xhr = 'content/select-image';
      		}

      		var template = `<a href="" class="w-100px h-100px card shadow-sm overflow-hidden mt-5 me-5 ${src}" data-xhr="${data_xhr}" data-id="${folder}">
								    <div class="card-body flex-column align-items-center p-0 file-box">`;

	      	if(response.type == 'img') {

	      		var template = template + `<img src="/dist/assets/${folder}" class="img-fluid">`

	      	}
	      	else if(response.type == 'video') {
	      		var template = template + `<i class="fa-duotone fa-clapperboard-play fa-2xl text-primary"></i><span class="mt-3 text-center">${file}</span>`;
	      	}
	      	else {
	      		var template = template + `<i class="fa-duotone fa-file fa-2xl text-primary"></i><span class="mt-3 text-center">${file}</span>`;
	      	}

	      	template += `	</div>
						</a>`;


			$(template).prependTo('[data-zone="'+response.zone+'"]');

			$('#technical-dropzone').addClass('d-none');			
			$('label.active').removeClass('active').prop('checked', false);
		}
	});

	myDropzone.on("complete", function(file) {
		myDropzone.removeFile(file);
	});
}

if($('#form-technical').length > 0) {
	var zone = $('.technical-pic').data('zone');
	technical_dropzone(path, zone, 'file-manager')
}

if($('#insurance-dropzone').length) {

	var folder = $('#insurance-dropzone').data('real-folder');
	var record = $('#insurance-dropzone').data('record');
	var input = $('#insurance-dropzone').data('input');

	var myDropzone = new Dropzone('#insurance-dropzone', {
	    url: path+'request/xhr/upload/upload.php?real-folder='+folder+'&record='+record+'&input='+input, // Set the url for your upload script location
	    paramName: "file", // The name that will be used to transfer the file
	    maxFiles: 10,
	    maxFilesize: 200, // MB
	    addRemoveLinks: true,
	    // capture: "image/*",
	    init: function() {
		    this.on("sending", function(file, xhr, formData) {
		       // var value = $("#technical-type").val();
		       // formData.append("type", value); // Append all the additional input data of your form here!
		    });
		},
	    success: function(file, response) {
			response = JSON.parse(response);
			
      		if($('#no-file-result').length > 0) {
      			$('#no-file-result').remove();
      		}

      		if(response.path === null) {
      			response.path = '';
      		}

      		var file = response.filename+'.'+response.ext;
      		var secure = response.secure;
      		var folder_url = encodeURI(response.path)+response.filename+'.'+response.ext;
      		var folder = response.path+response.filename+'.'+response.ext;

      		/*var template = `<a href="" class="w-100px h-100px card shadow-sm overflow-hidden mt-5 me-5">
								    <div class="card-body flex-column align-items-center p-0 file-box">`;

	      	if(response.type == 'img') {

	      		var template = template + `<img src="/dist/assets/${folder}" class="img-fluid">`

	      	}
	      	else if(response.type == 'video') {
	      		var template = template + `<i class="fa-duotone fa-clapperboard-play fa-2xl text-primary"></i><span class="mt-3 text-center">${file}</span>`;
	      	}
	      	else {
	      		var template = template + `<i class="fa-duotone fa-file fa-2xl text-primary"></i><span class="mt-3 text-center">${file}</span>`;
	      	}*/

	      	var template = `<div class="col-md-6 col-lg-4 col-xl-3">
					        <div class="card h-100 ">
					            <div class="card-body d-flex justify-content-center text-center flex-column p-8">
					                <a href="${secure}" target="_blank" class="text-gray-800 text-hover-primary d-flex flex-column">
					                    <div class="symbol symbol-75px mb-5">
					                        <img src="/dist/assets/img/admin/pdf.svg" class="theme-light-show" alt="">	                                                        
					                    </div>
					                    <div class="fs-5 fw-bold mb-2">
					                        ${file}                           
					                    </div>
					                </a>
					            </div>
					        </div>
					    </div>`;


			$(template).prependTo('#file-result');
		}
	});

	myDropzone.on("complete", function(file) {
		myDropzone.removeFile(file);
	});

}


	// Class definition
	var KTFileManagerList = function () {
	    // Define shared variables
	    var datatable;
	    var table

	    // Define template element variables
	    var uploadTemplate;
	    var renameTemplate;
	    var actionTemplate;
	    var checkboxTemplate;


	    // Private functions
	    const initTemplates = () => {
	        uploadTemplate = document.querySelector('[data-kt-filemanager-template="upload"]');
	        renameTemplate = document.querySelector('[data-kt-filemanager-template="rename"]');
	        actionTemplate = document.querySelector('[data-kt-filemanager-template="action"]');
	        checkboxTemplate = document.querySelector('[data-kt-filemanager-template="checkbox"]');
	    }

	    const initDatatable = () => {
	        // Set date data order
	        const tableRows = table.querySelectorAll('tbody tr');

	        tableRows.forEach(row => {
	            const dateRow = row.querySelectorAll('td');
	            const dateCol = dateRow[3]; // select date from 4th column in table
	            const realDate = moment(dateCol.innerHTML, "DD MMM YYYY, LT").format();
	            // dateCol.setAttribute('data-order', realDate);
	        });

	        const foldersListOptions = {
	            "info": false,
	            'order': [],
	            // "scrollY": "700px",
	            // "scrollCollapse": true,
	            "paging": false,
	            'ordering': false,
	            'columns': [
	                { data: 'checkbox' },
	                { data: 'name' },
	                { data: 'size' },
	                { data: 'date' },
	                { data: 'action' },
	            ],
	            'language': {
	                emptyTable: `<div class="d-flex flex-column flex-center">
	                    <img src="${hostUrl}media/illustrations/sketchy-1/5.png" class="mw-400px" />
	                    <div class="fs-1 fw-bolder text-dark">No items found.</div>
	                    <div class="fs-6">Start creating new folders or uploading a new file!</div>
	                </div>`
	            }
	        };

	        const filesListOptions = {
	            "info": false,
	            'order': [],
	            'pageLength': 10,
	            "lengthChange": false,
	            'ordering': false,
	            'columns': [
	                { data: 'checkbox' },
	                { data: 'name' },
	                { data: 'size' },
	                { data: 'date' },
	                { data: 'action' },
	            ],
	            'language': {
	                emptyTable: `<div class="d-flex flex-column flex-center">
	                    <img src="${hostUrl}media/illustrations/sketchy-1/5.png" class="mw-400px" />
	                    <div class="fs-1 fw-bolder text-dark mb-4">No items found.</div>
	                    <div class="fs-6">Start creating new folders or uploading a new file!</div>
	                </div>`
	            },
	            conditionalPaging: true
	        };

	        // Define datatable options to load
	        var loadOptions;
	        if (table.getAttribute('data-kt-filemanager-table') === 'folders') {
	            loadOptions = foldersListOptions;
	        } else {
	            loadOptions = filesListOptions;
	        }

	        // Init datatable --- more info on datatables: https://datatables.net/manual/
	        datatable = $(table).DataTable(loadOptions);

	        // Re-init functions on every table re-draw -- more info: https://datatables.net/reference/event/draw
	        datatable.on('draw', function () {
	            initToggleToolbar();
	            // handleDeleteRows();
	            toggleToolbars();
	            resetNewFolder();
	            KTMenu.createInstances();
	            // initCopyLink();
	            countTotalItems();
	            handleRename();
	        });
	    }

	    // Search Datatable --- official docs reference: https://datatables.net/reference/api/search()
	    const handleSearchDatatable = () => {
	        const filterSearch = document.querySelector('[data-kt-filemanager-table-filter="search"]');
	        filterSearch.addEventListener('keyup', function (e) {
	            datatable.search(e.target.value).draw();
	        });
	    }

	    // Delete customer
	    /*const handleDeleteRows = () => {
	        // Select all delete buttons
	        const deleteButtons = table.querySelectorAll('[data-kt-filemanager-table-filter="delete_row"]');

	        deleteButtons.forEach(d => {
	            // Delete button on click
	            d.addEventListener('click', function (e) {
	                e.preventDefault();

	                // Select parent row
	                const parent = e.target.closest('tr');

	                // Get customer name
	                const fileName = parent.querySelectorAll('td')[1].innerText;

	                // SweetAlert2 pop up --- official docs reference: https://sweetalert2.github.io/
	                Swal.fire({
	                    text: "Are you sure you want to delete " + fileName + "?",
	                    icon: "warning",
	                    showCancelButton: true,
	                    buttonsStyling: false,
	                    confirmButtonText: "Yes, delete!",
	                    cancelButtonText: "No, cancel",
	                    customClass: {
	                        confirmButton: "btn fw-bold btn-danger",
	                        cancelButton: "btn fw-bold btn-active-light-primary"
	                    }
	                }).then(function (result) {
	                    if (result.value) {
	                        Swal.fire({
	                            text: "You have deleted " + fileName + "!.",
	                            icon: "success",
	                            buttonsStyling: false,
	                            confirmButtonText: "Ok, got it!",
	                            customClass: {
	                                confirmButton: "btn fw-bold btn-primary",
	                            }
	                        }).then(function () {
	                            // Remove current row
	                            datatable.row($(parent)).remove().draw();
	                        });
	                    } else if (result.dismiss === 'cancel') {
	                        Swal.fire({
	                            text: customerName + " was not deleted.",
	                            icon: "error",
	                            buttonsStyling: false,
	                            confirmButtonText: "Ok, got it!",
	                            customClass: {
	                                confirmButton: "btn fw-bold btn-primary",
	                            }
	                        });
	                    }
	                });
	            })
	        });
	    }*/

	    // Init toggle toolbar
	    const initToggleToolbar = () => {
	        // Toggle selected action toolbar
	        // Select all checkboxes
	        var checkboxes = table.querySelectorAll('[type="checkbox"]');
	        if (table.getAttribute('data-kt-filemanager-table') === 'folders') {
	            checkboxes = document.querySelectorAll('#kt_file_manager_list_wrapper [type="checkbox"]');
	        }

	        // Select elements
	        const deleteSelected = document.querySelector('[data-kt-filemanager-table-select="delete_selected"]');

	        // Toggle delete selected toolbar
	        checkboxes.forEach(c => {
	            // Checkbox on click event
	            c.addEventListener('click', function () {
	                console.log(c);
	                setTimeout(function () {
	                    toggleToolbars();
	                }, 50);
	            });
	        });

	        // Deleted selected rows
	        deleteSelected.addEventListener('click', function () {
	            // SweetAlert2 pop up --- official docs reference: https://sweetalert2.github.io/
	            Swal.fire({
	                text: "Are you sure you want to delete selected files or folders?",
	                icon: "warning",
	                showCancelButton: true,
	                buttonsStyling: false,
	                confirmButtonText: "Yes, delete!",
	                cancelButtonText: "No, cancel",
	                customClass: {
	                    confirmButton: "btn fw-bold btn-danger",
	                    cancelButton: "btn fw-bold btn-active-light-primary"
	                }
	            }).then(function (result) {
	                if (result.value) {
	                    Swal.fire({
	                        text: "You have deleted all selected  files or folders!.",
	                        icon: "success",
	                        buttonsStyling: false,
	                        confirmButtonText: "Ok, got it!",
	                        customClass: {
	                            confirmButton: "btn fw-bold btn-primary",
	                        }
	                    }).then(function () {
	                        // Remove all selected customers
	                        checkboxes.forEach(c => {
	                            if (c.checked) {
	                                datatable.row($(c.closest('tbody tr'))).remove().draw();
	                            }
	                        });

	                        // Remove header checked box
	                        const headerCheckbox = table.querySelectorAll('[type="checkbox"]')[0];
	                        headerCheckbox.checked = false;
	                    });
	                } else if (result.dismiss === 'cancel') {
	                    Swal.fire({
	                        text: "Selected  files or folders was not deleted.",
	                        icon: "error",
	                        buttonsStyling: false,
	                        confirmButtonText: "Ok, got it!",
	                        customClass: {
	                            confirmButton: "btn fw-bold btn-primary",
	                        }
	                    });
	                }
	            });
	        });
	    }

	    // Toggle toolbars
	    const toggleToolbars = () => {
	        // Define variables
	        const toolbarBase = document.querySelector('[data-kt-filemanager-table-toolbar="base"]');
	        const toolbarSelected = document.querySelector('[data-kt-filemanager-table-toolbar="selected"]');
	        const selectedCount = document.querySelector('[data-kt-filemanager-table-select="selected_count"]');

	        // Select refreshed checkbox DOM elements 
	        const allCheckboxes = table.querySelectorAll('tbody [type="checkbox"]');

	        // Detect checkboxes state & count
	        let checkedState = false;
	        let count = 0;

	        // Count checked boxes
	        allCheckboxes.forEach(c => {
	            if (c.checked) {
	                checkedState = true;
	                count++;
	            }
	        });

	        // Toggle toolbars
	        if (checkedState) {
	            selectedCount.innerHTML = count;
	            toolbarBase.classList.add('d-none');
	            toolbarSelected.classList.remove('d-none');
	        } else {
	            toolbarBase.classList.remove('d-none');
	            toolbarSelected.classList.add('d-none');
	        }
	    }

	    // Handle new folder
	    const handleNewFolder = () => {
	        // Select button
	        const newFolder = document.getElementById('kt_file_manager_new_folder');

	        // Handle click action
	        newFolder.addEventListener('click', e => {
	            e.preventDefault();

	            // Ignore if input already exist
	            if (table.querySelector('#kt_file_manager_new_folder_row')) {
	                return;
	            }

	            // Add new blank row to datatable
	            const tableBody = table.querySelector('tbody');
	            const rowElement = uploadTemplate.cloneNode(true); // Clone template markup
	            tableBody.prepend(rowElement);

	            // Define template interactive elements
	            const rowForm = rowElement.querySelector('#kt_file_manager_add_folder_form');
	            const rowButton = rowElement.querySelector('#kt_file_manager_add_folder');
	            const cancelButton = rowElement.querySelector('#kt_file_manager_cancel_folder');
	            const folderIcon = rowElement.querySelector('.svg-icon-2x');
	            const rowInput = rowElement.querySelector('[name="new_folder_name"]');

	            // Define validator
	            // Init form validation rules. For more info check the FormValidation plugin's official documentation:https://formvalidation.io/
	            var validator = FormValidation.formValidation(
	                rowForm,
	                {
	                    fields: {
	                        'new_folder_name': {
	                            validators: {
	                                notEmpty: {
	                                    message: 'Folder name is required'
	                                }
	                            }
	                        },
	                    },
	                    plugins: {
	                        trigger: new FormValidation.plugins.Trigger(),
	                        bootstrap: new FormValidation.plugins.Bootstrap5({
	                            rowSelector: '.fv-row',
	                            eleInvalidClass: '',
	                            eleValidClass: ''
	                        })
	                    }
	                }
	            );

	            // Handle add new folder button
	            rowButton.addEventListener('click', e => {
	                e.preventDefault();

	                // Activate indicator
	                rowButton.setAttribute("data-kt-indicator", "on");

	                // Validate form before submit
	                if (validator) {
	                    validator.validate().then(function (status) {
	                        //console.log('validated!');


	                        if (status == 'Valid') {
	                            // Simulate process for demo only
	                            setTimeout(function () {
	                                // Create folder link
	                                const folderLink = document.createElement('a');
	                                const folderLinkClasses = ['text-gray-800', 'text-hover-primary'];
	                                folderLink.setAttribute('href', '?page=apps/file-manager/blank');
	                                folderLink.classList.add(...folderLinkClasses);
	                                folderLink.innerText = rowInput.value;

	                                const newRow = datatable.row.add({
	                                    'checkbox': checkboxTemplate.innerHTML,
	                                    'name': folderIcon.outerHTML + folderLink.outerHTML,
	                                    "size": '-',
	                                    "date": '-',
	                                    'action': actionTemplate.innerHTML
	                                }).node();
	                                $(newRow).find('td').eq(4).attr('data-kt-filemanager-table', 'action_dropdown');
	                                $(newRow).find('td').eq(4).addClass('text-end'); // Add custom class to last 'td' element --- more info: https://datatables.net/forums/discussion/22341/row-add-cell-class

	                                // Re-sort datatable to allow new folder added at the top
	                                var index = datatable.row(0).index(),
	                                    rowCount = datatable.data().length - 1,
	                                    insertedRow = datatable.row(rowCount).data(),
	                                    tempRow;

	                                for (var i = rowCount; i > index; i--) {
	                                    tempRow = datatable.row(i - 1).data();
	                                    datatable.row(i).data(tempRow);
	                                    datatable.row(i - 1).data(insertedRow);
	                                }


									// xhr_send('media/add-folder', token, $('#kt_file_manager_add_folder'));

	                                // toastr.success(rowInput.value + ' was created!');

	                                // Disable indicator
	                                rowButton.removeAttribute("data-kt-indicator");

	                                // Reset input
	                                rowInput.value = '';

	                                datatable.draw(false);

	                                setTimeout(function () {
	                            		location.reload();
	                            	}, 1500);

	                            }, 1000);
	                        } else {
	                            // Disable indicator
	                            rowButton.removeAttribute("data-kt-indicator");
	                        }
	                    });
	                }
	            });

	            // Handle cancel new folder button
	            cancelButton.addEventListener('click', e => {
	                e.preventDefault();

	                // Activate indicator
	                cancelButton.setAttribute("data-kt-indicator", "on");

	                setTimeout(function () {
	                    // Disable indicator
	                    cancelButton.removeAttribute("data-kt-indicator");

	                    // Toggle toastr
	                    toastr.options = {
	                        "closeButton": true,
	                        "debug": false,
	                        "newestOnTop": false,
	                        "progressBar": false,
	                        "positionClass": "toastr-top-right",
	                        "preventDuplicates": false,
	                        "showDuration": "300",
	                        "hideDuration": "1000",
	                        "timeOut": "5000",
	                        "extendedTimeOut": "1000",
	                        "showEasing": "swing",
	                        "hideEasing": "linear",
	                        "showMethod": "fadeIn",
	                        "hideMethod": "fadeOut"
	                    };

	                    toastr.error('Cancelled new folder creation');
	                    resetNewFolder();
	                }, 1000);
	            });
	        });
	    }

	    // Reset add new folder input
	    const resetNewFolder = () => {
	        const newFolderRow = table.querySelector('#kt_file_manager_new_folder_row');

	        if (newFolderRow) {
	            newFolderRow.parentNode.removeChild(newFolderRow);
	        }
	    }

	    // Handle rename file or folder
	    const handleRename = () => {
	        const renameButton = table.querySelectorAll('[data-kt-filemanager-table="rename"]');     

	        renameButton.forEach(button => {
	            button.addEventListener('click', renameCallback);
	        });
	    }

	    // Rename callback
	    const renameCallback = (e) => {
	        e.preventDefault();

	        // Define shared value
	        let nameValue;

	        // Stop renaming if there's an input existing
	        if (table.querySelectorAll('#kt_file_manager_rename_input').length > 0) {
	            Swal.fire({
	                text: "Unsaved input detected. Please save or cancel the current item",
	                icon: "warning",
	                buttonsStyling: false,
	                confirmButtonText: "Ok, got it!",
	                customClass: {
	                    confirmButton: "btn fw-bold btn-danger"
	                }
	            });

	            return;
	        }

	        // Select parent row
	        const parent = e.target.closest('tr');

	        // Get name column
	        const nameCol = parent.querySelectorAll('td')[1];
	        const colIcon = nameCol.querySelector('.svg-icon');
	        nameValue = nameCol.innerText;

	        // Set rename input template
	        const renameInput = renameTemplate.cloneNode(true);
	        renameInput.querySelector('#kt_file_manager_rename_folder_icon').innerHTML = colIcon.outerHTML;

	        // Swap current column content with input template
	        nameCol.innerHTML = renameInput.innerHTML;

	        // Set input value with current file/folder name
	        parent.querySelector('#kt_file_manager_rename_input').value = nameValue;

	        // Rename file / folder validator
	        var renameValidator = FormValidation.formValidation(
	            nameCol,
	            {
	                fields: {
	                    'rename_folder_name': {
	                        validators: {
	                            notEmpty: {
	                                message: 'Name is required'
	                            }
	                        }
	                    },
	                },
	                plugins: {
	                    trigger: new FormValidation.plugins.Trigger(),
	                    bootstrap: new FormValidation.plugins.Bootstrap5({
	                        rowSelector: '.fv-row',
	                        eleInvalidClass: '',
	                        eleValidClass: ''
	                    })
	                }
	            }
	        );

	        // Rename input button action
	        const renameInputButton = document.querySelector('#kt_file_manager_rename_folder');
	        renameInputButton.addEventListener('click', e => {
	            e.preventDefault();

	            // Detect if valid
	            if (renameValidator) {
	                renameValidator.validate().then(function (status) {
	                    console.log('validated!');

	                    if (status == 'Valid') {
	                        // Pop up confirmation
	                        Swal.fire({
	                            text: "Are you sure you want to rename " + nameValue + "?",
	                            icon: "warning",
	                            showCancelButton: true,
	                            buttonsStyling: false,
	                            confirmButtonText: "Yes, rename it!",
	                            cancelButtonText: "No, cancel",
	                            customClass: {
	                                confirmButton: "btn fw-bold btn-danger",
	                                cancelButton: "btn fw-bold btn-active-light-primary"
	                            }
	                        }).then(function (result) {
	                            if (result.value) {
	                                Swal.fire({
	                                    text: "You have renamed " + nameValue + "!.",
	                                    icon: "success",
	                                    buttonsStyling: false,
	                                    confirmButtonText: "Ok, got it!",
	                                    customClass: {
	                                        confirmButton: "btn fw-bold btn-primary",
	                                    }
	                                }).then(function () {
	                                    // Get new file / folder name value
	                                    const newValue = document.querySelector('#kt_file_manager_rename_input').value;

	                                    // New column data template
	                                    const newData = `<div class="d-flex align-items-center">
	                                        ${colIcon.outerHTML}
	                                        <a href="?page=apps/file-manager/files/" class="text-gray-800 text-hover-primary">${newValue}</a>
	                                    </div>`;

	                                    // Draw datatable with new content -- Add more events here for any server-side events
	                                    datatable.cell($(nameCol)).data(newData).draw();
	                                });
	                            } else if (result.dismiss === 'cancel') {
	                                Swal.fire({
	                                    text: nameValue + " was not renamed.",
	                                    icon: "error",
	                                    buttonsStyling: false,
	                                    confirmButtonText: "Ok, got it!",
	                                    customClass: {
	                                        confirmButton: "btn fw-bold btn-primary",
	                                    }
	                                });
	                            }
	                        });
	                    }
	                });
	            }
	        });

	        // Cancel rename input
	        const cancelInputButton = document.querySelector('#kt_file_manager_rename_folder_cancel');
	        cancelInputButton.addEventListener('click', e => {
	            e.preventDefault();

	            // Simulate process for demo only
	            cancelInputButton.setAttribute("data-kt-indicator", "on");

	            setTimeout(function () {
	                const revertTemplate = `<div class="d-flex align-items-center">
	                    ${colIcon.outerHTML}
	                    <a href="?page=apps/file-manager/files/" class="text-gray-800 text-hover-primary">${nameValue}</a>
	                </div>`;

	                // Remove spinner
	                cancelInputButton.removeAttribute("data-kt-indicator");

	                // Draw datatable with new content -- Add more events here for any server-side events
	                datatable.cell($(nameCol)).data(revertTemplate).draw();

	                // Toggle toastr
	                toastr.options = {
	                    "closeButton": true,
	                    "debug": false,
	                    "newestOnTop": false,
	                    "progressBar": false,
	                    "positionClass": "toastr-top-right",
	                    "preventDuplicates": false,
	                    "showDuration": "300",
	                    "hideDuration": "1000",
	                    "timeOut": "5000",
	                    "extendedTimeOut": "1000",
	                    "showEasing": "swing",
	                    "hideEasing": "linear",
	                    "showMethod": "fadeIn",
	                    "hideMethod": "fadeOut"
	                };

	                toastr.error('Cancelled rename function');
	            }, 1000);
	        });
	    }

	    // Init dropzone
	    const initDropzone = () => {
	        // set the dropzone container id
	        const id = "#kt_modal_upload_dropzone";
	        const dropzone = document.querySelector(id);

	        // set the preview element template
	        var previewNode = dropzone.querySelector(".dropzone-item");
	        previewNode.id = "";
	        var previewTemplate = previewNode.parentNode.innerHTML;
	        previewNode.parentNode.removeChild(previewNode);

	        var myDropzone = new Dropzone(id, { // Make the whole body a dropzone
	            url: "path/to/your/server", // Set the url for your upload script location
	            parallelUploads: 10,
	            previewTemplate: previewTemplate,
	            maxFilesize: 1, // Max filesize in MB
	            autoProcessQueue: false, // Stop auto upload
	            autoQueue: false, // Make sure the files aren't queued until manually added
	            previewsContainer: id + " .dropzone-items", // Define the container to display the previews
	            clickable: id + " .dropzone-select" // Define the element that should be used as click trigger to select files.
	        });

	        myDropzone.on("addedfile", function (file) {
	            // Hook each start button
	            file.previewElement.querySelector(id + " .dropzone-start").onclick = function () {
	                // myDropzone.enqueueFile(file); -- default dropzone function

	                // Process simulation for demo only
	                const progressBar = file.previewElement.querySelector('.progress-bar');
	                progressBar.style.opacity = "1";
	                var width = 1;
	                var timer = setInterval(function () {
	                    if (width >= 100) {
	                        myDropzone.emit("success", file);
	                        myDropzone.emit("complete", file);
	                        clearInterval(timer);
	                    } else {
	                        width++;
	                        progressBar.style.width = width + '%';
	                    }
	                }, 20);
	            };

	            const dropzoneItems = dropzone.querySelectorAll('.dropzone-item');
	            dropzoneItems.forEach(dropzoneItem => {
	                dropzoneItem.style.display = '';
	            });
	            dropzone.querySelector('.dropzone-upload').style.display = "inline-block";
	            dropzone.querySelector('.dropzone-remove-all').style.display = "inline-block";
	        });

	        // Hide the total progress bar when nothing's uploading anymore
	        myDropzone.on("complete", function (file) {
	            const progressBars = dropzone.querySelectorAll('.dz-complete');
	            setTimeout(function () {
	                progressBars.forEach(progressBar => {
	                    progressBar.querySelector('.progress-bar').style.opacity = "0";
	                    progressBar.querySelector('.progress').style.opacity = "0";
	                    progressBar.querySelector('.dropzone-start').style.opacity = "0";
	                });
	            }, 300);
	        });

	        // Setup the buttons for all transfers
	        dropzone.querySelector(".dropzone-upload").addEventListener('click', function () {
	            // myDropzone.processQueue(); --- default dropzone process

	            // Process simulation for demo only
	            myDropzone.files.forEach(file => {
	                const progressBar = file.previewElement.querySelector('.progress-bar');
	                progressBar.style.opacity = "1";
	                var width = 1;
	                var timer = setInterval(function () {
	                    if (width >= 100) {
	                        myDropzone.emit("success", file);
	                        myDropzone.emit("complete", file);
	                        clearInterval(timer);
	                    } else {
	                        width++;
	                        progressBar.style.width = width + '%';
	                    }
	                }, 20);
	            });
	        });

	        // Setup the button for remove all files
	        dropzone.querySelector(".dropzone-remove-all").addEventListener('click', function () {
	            Swal.fire({
	                text: "Are you sure you would like to remove all files?",
	                icon: "warning",
	                showCancelButton: true,
	                buttonsStyling: false,
	                confirmButtonText: "Yes, remove it!",
	                cancelButtonText: "No, return",
	                customClass: {
	                    confirmButton: "btn btn-primary",
	                    cancelButton: "btn btn-active-light"
	                }
	            }).then(function (result) {
	                if (result.value) {
	                    dropzone.querySelector('.dropzone-upload').style.display = "none";
	                    dropzone.querySelector('.dropzone-remove-all').style.display = "none";
	                    myDropzone.removeAllFiles(true);
	                } else if (result.dismiss === 'cancel') {
	                    Swal.fire({
	                        text: "Your files was not removed!.",
	                        icon: "error",
	                        buttonsStyling: false,
	                        confirmButtonText: "Ok, got it!",
	                        customClass: {
	                            confirmButton: "btn btn-primary",
	                        }
	                    });
	                }
	            });
	        });

	        // On all files completed upload
	        myDropzone.on("queuecomplete", function (progress) {
	            const uploadIcons = dropzone.querySelectorAll('.dropzone-upload');
	            uploadIcons.forEach(uploadIcon => {
	                uploadIcon.style.display = "none";
	            });
	        });

	        // On all files removed
	        myDropzone.on("removedfile", function (file) {
	            if (myDropzone.files.length < 1) {
	                dropzone.querySelector('.dropzone-upload').style.display = "none";
	                dropzone.querySelector('.dropzone-remove-all').style.display = "none";
	            }
	        });
	    }

	    // Init copy link
	    /*const initCopyLink = () => {
	        // Select all copy link elements
	        const elements = table.querySelectorAll('[data-kt-filemanger-table="copy_link"]');

	        elements.forEach(el => {
	            // Define elements
	            const button = el.querySelector('button');
	            const generator = el.querySelector('[data-kt-filemanger-table="copy_link_generator"]');
	            const result = el.querySelector('[data-kt-filemanger-table="copy_link_result"]');
	            const input = el.querySelector('input');

	            // Click action
	            button.addEventListener('click', e => {
	                e.preventDefault();

	                // Reset toggle
	                generator.classList.remove('d-none');
	                result.classList.add('d-none');

	                var linkTimeout;
	                clearTimeout(linkTimeout);
	                linkTimeout = setTimeout(() => {
	                    generator.classList.add('d-none');
	                    result.classList.remove('d-none');
	                    input.select();
	                }, 2000);
	            });
	        });
	    }*/

	    // Handle move to folder
	    const handleMoveToFolder = () => {
	        const element = document.querySelector('#kt_modal_move_to_folder');
	        const form = element.querySelector('#kt_modal_move_to_folder_form');
	        const saveButton = form.querySelector('#kt_modal_move_to_folder_submit');
	        const moveModal = new bootstrap.Modal(element);

	        // Init form validation rules. For more info check the FormValidation plugin's official documentation:https://formvalidation.io/
	        var validator = FormValidation.formValidation(
	            form,
	            {
	                fields: {
	                    'move_to_folder': {
	                        validators: {
	                            notEmpty: {
	                                message: 'Please select a folder.'
	                            }
	                        }
	                    },
	                },

	                plugins: {
	                    trigger: new FormValidation.plugins.Trigger(),
	                    bootstrap: new FormValidation.plugins.Bootstrap5({
	                        rowSelector: '.fv-row',
	                        eleInvalidClass: '',
	                        eleValidClass: ''
	                    })
	                }
	            }
	        );

	        saveButton.addEventListener('click', e => {
	            e.preventDefault();

	            saveButton.setAttribute("data-kt-indicator", "on");

	            if (validator) {
	                validator.validate().then(function (status) {
	                    console.log('validated!');

	                    if (status == 'Valid') {
	                        // Simulate process for demo only
	                        setTimeout(function () {

	                            Swal.fire({
	                                text: "Are you sure you would like to move to this folder",
	                                icon: "warning",
	                                showCancelButton: true,
	                                buttonsStyling: false,
	                                confirmButtonText: "Yes, move it!",
	                                cancelButtonText: "No, return",
	                                customClass: {
	                                    confirmButton: "btn btn-primary",
	                                    cancelButton: "btn btn-active-light"
	                                }
	                            }).then(function (result) {
	                                if (result.isConfirmed) {
	                                    form.reset(); // Reset form	
	                                    moveModal.hide(); // Hide modal			

	                                    toastr.options = {
	                                        "closeButton": true,
	                                        "debug": false,
	                                        "newestOnTop": false,
	                                        "progressBar": false,
	                                        "positionClass": "toastr-top-right",
	                                        "preventDuplicates": false,
	                                        "showDuration": "300",
	                                        "hideDuration": "1000",
	                                        "timeOut": "5000",
	                                        "extendedTimeOut": "1000",
	                                        "showEasing": "swing",
	                                        "hideEasing": "linear",
	                                        "showMethod": "fadeIn",
	                                        "hideMethod": "fadeOut"
	                                    };

	                                    toastr.success('1 item has been moved.');

	                                    saveButton.removeAttribute("data-kt-indicator");
	                                } else {
	                                    Swal.fire({
	                                        text: "Your action has been cancelled!.",
	                                        icon: "error",
	                                        buttonsStyling: false,
	                                        confirmButtonText: "Ok, got it!",
	                                        customClass: {
	                                            confirmButton: "btn btn-primary",
	                                        }
	                                    });

	                                    saveButton.removeAttribute("data-kt-indicator");
	                                }
	                            });
	                        }, 500);
	                    } else {
	                        saveButton.removeAttribute("data-kt-indicator");
	                    }
	                });
	            }
	        });
	    }

	    // Count total number of items
	    const countTotalItems = () => {
	        const counter = document.getElementById('kt_file_manager_items_counter');

	        // Count total number of elements in datatable --- more info: https://datatables.net/reference/api/count()
	        counter.innerText = datatable.rows().count() + ' items';
	    }

	    // Public methods
	    return {
	        init: function () {
	            table = document.querySelector('#kt_file_manager_list');

	            if (!table) {
	                return;
	            }

	            initTemplates();
	            initDatatable();
	            initToggleToolbar();
	            handleSearchDatatable();
	            // handleDeleteRows();
	            handleNewFolder();
	            initDropzone();
	            // initCopyLink();
	            handleRename();
	            handleMoveToFolder();
	            countTotalItems();
	            KTMenu.createInstances();
	        }
	    }
	}();

	// On document ready
	KTUtil.onDOMContentLoaded(function () {
	    KTFileManagerList.init();
	});

	// Class definition
	var KTAppInvoicesCreate = function () {
	    var form;

		// Private functions
		var updateTotal = function(custom_price = false) {

			console.log(custom_price)
			var items = [].slice.call(form.querySelectorAll('[data-kt-element="items"] [data-kt-element="item"]'));
			var vatTotal = 0;
			var htvaTotal = 0;
			var grandTotal = 0;
			var wcTotal = 0;
			var prodTotal = 0;

			var format = wNumb({
				suffix: ' €',
				mark: ',',
				decimals: 2,
				thousand: '.'
			});

			var formatWc = wNumb({
				suffix: ' Wc',
				mark: ',',
				decimals: 0,
				thousand: '.'
			});

			var formatPriceWc = wNumb({
				suffix: ' €/Wc',
				mark: ',',
				decimals: 2,
				thousand: '.'
			});

			var formatProd = wNumb({
				suffix: ' kWh/an',
				mark: ',',
				decimals: 0,
				thousand: '.'
			});

			items.map(function (item) {
	            var quantity = item.querySelector('[data-kt-element="quantity"]');
				var wc = item.querySelector('[data-kt-element="wc"]');
				var main_category = item.querySelector('[data-kt-element="main-category"]');
				var category = item.querySelector('[data-kt-element="category"]');
				var optional = item.querySelector('[data-kt-element="optional"]');
				var optionalValue = (optional && optional.value == 1);

				var quantityValue = parseFloat(quantity.value);
				quantityValue = (!quantityValue || quantityValue < 0) ?  1 : quantityValue;

				var wcValue = parseInt(wc.value);
				wcValue = (!wcValue) ? 0 : wcValue;

				// only pv
				if(category.value == 1 && !optionalValue) {
					wcTotal += wcValue * quantityValue;
				}
			});

			items.map(function (item) {
	            var quantity = item.querySelector('[data-kt-element="quantity"]');
				var price = item.querySelector('[data-kt-element="price"]');
				var vat = item.querySelector('[data-kt-element="vat"]');
				var ratio = item.querySelector('[data-kt-element="ratio"]');
				var priceRef = item.querySelector('[data-kt-element="price-ref"]');
				var optional = item.querySelector('[data-kt-element="optional"]');
				var optionalValue = (optional && optional.value == 1);

				var priceValue = format.from(price.value);
				priceValue = (!priceValue) ? 0 : priceValue;

				var priceRefValue = format.from(priceRef.value);
				priceRefValue = (!priceRefValue) ? 0 : priceRefValue;

				var ratioValue = parseInt(ratio.value);
				ratioValue = (!ratioValue) ? 0 : ratioValue;

				if(ratioValue == 1 && custom_price == false) { priceValue = priceRefValue * wcTotal; }
				
				if(priceValue < 0) { price.classList.add('text-danger') } else { price.classList.remove('text-danger') }

				var quantityValue = parseFloat(quantity.value);
				quantityValue = (!quantityValue || quantityValue < 0) ?  1 : quantityValue;

				var vatValue = parseInt(vat.value);
				// vatValue = (!vatValue || vatValue < 0) ?  1 : vatValue;

				price.value = format.to(priceValue);

				quantity.value = quantityValue;
				vat.value = vatValue;
				ratio.value = ratioValue;

				item.querySelector('[data-kt-element="total"]').innerText = format.to(priceValue * quantityValue);			

				if(!optionalValue) {
					vatTotal += priceValue * vatValue / 100 * quantityValue;
					htvaTotal += priceValue * quantityValue;
				}

				
			});
			grandTotal = htvaTotal + vatTotal;

			form.querySelector('[data-kt-element="total-htva"]').innerText = format.to(htvaTotal);
			form.querySelector('[data-kt-element="total-tva"]').innerText = format.to(vatTotal);
			form.querySelector('[data-kt-element="grand-total"]').innerText = format.to(grandTotal);

			var quote = $('[data-quote]').data('quote');

			// pour l'édition du devis
			if($('#prod').length > 0) {
				var priceWc = htvaTotal / wcTotal;
				var efficiency = $('[data-efficiency]').data('efficiency');
				prodTotal = wcTotal * parseFloat($('#productible').val()) / 1000;
				// console.log(prodtTotal, wcTotal, parseFloat($('#productible').val()))
				$.post(path+'request/xhr/quote/get-chart.php', { token: token, prod: prodTotal, price: grandTotal, wc: wcTotal, quote: quote, efficiency: efficiency }, function(response) {
					$('#profitability').html(response.profitability);
					$('#amortization').html(response.amortization);


				  	myChart.data.labels = ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jui', 'Juil', 'Aou', 'Sep', 'Oct', 'Nov', 'Dec'];
					myChart.data.datasets[0].data = response.chart;

					// re-render the chart
					myChart.update();

					exportChart.data.labels = ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jui', 'Juil', 'Aou', 'Sep', 'Oct', 'Nov', 'Dec'];
					exportChart.data.datasets[0].data = response.chart;

					// re-render the chart
					exportChart.update();

					setTimeout(() => {
						if(wcTotal > 0) {
							var quote = $('#id-quote').val();

							var image = exportChart.toBase64Image('image/jpg', 1);
							$.post(path+'request/xhr/quote/export-chart.php', { token: token, quote: quote, image: image }, function(response2) {

							}, 'json');
						}				
					}, "1000")

				}, 'json');

				if(prodTotal < $('[data-conso]').data('conso')) {
					$('#wc, #prod').addClass('text-danger');
				}
				else {
					$('#wc, #prod').removeClass('text-danger');
				}

				form.querySelector('#wc').innerText = formatWc.to(wcTotal);
				form.querySelector('#wc-total').value = wcTotal;
				form.querySelector('#prod').innerText = formatProd.to(prodTotal);
				form.querySelector('#price-wc').innerText = formatPriceWc.to(priceWc);
				form.querySelector('#price').innerText = format.to(grandTotal);	
			}

			// modification d'un devis
			if($('#quote-amount-ttc').length > 0) {
				var block = [];
				$('[data-block]').each(function() {
					if(!$(this).hasClass('locked')) {
						block.push($(this).data('block'));
					}
				});

				$.post(path+'request/xhr/quote/check-quote-deposit.php', { token: token, quote: quote, block: block, htva: htvaTotal, total: grandTotal }, function(response) {
					$.each(response.deposit_htva, function(i, item) {
						$('[data-block='+i+']').find('[data-amount=htva]').html(item);
					});

					$.each(response.deposit_ttc, function(i, item) {
						$('[data-block='+i+']').find('[data-amount=ttc]').html(item);
					});

					$('#new-total-htva').html(response.total_htva);
					$('#new-total-ttc').html(response.total_ttc);
					$('#total-ttc').val(response.total_ttc.replace(' €', ''));	

				}, 'json');
			}
		}

		var checkPriceUpdate = function(element) {
			$('#warning-price').addClass('d-none');
		
			$('[data-kt-element="item"]').each(function() {

				if($(this).find('[data-kt-element="price-ref-today"]') .length > 0) {
					var price_ref = $(this).find('[data-kt-element="price-ref"]').val();
					var price_today = $(this).find('[data-kt-element="price-ref-today"]').val();

					if(price_ref != price_today) {
						$('#warning-price').removeClass('d-none');
						$(this).find('[data-kt-element="price"]').addClass('border-danger');
					}
				}
			});
		}

		var updatePrice = function(element) {
			$('[data-kt-element="item"]').each(function() {
				if($(this).find('[data-kt-element="price-ref-today"]').length > 0) {
					var price_ref = $(this).find('[data-kt-element="price-ref"]').val();
					var price_today = $(this).find('[data-kt-element="price-ref-today"]').val();

					if(price_ref != price_today) {

						console.log(price_ref, price_today);
						$(this).find('[data-kt-element="price-ref"]').val(price_today);
						$(this).find('[data-kt-element="price"]').val(price_today);
						$(this).find('[data-kt-element="price"]').removeClass('border-danger');
					}

					$('#warning-price').addClass('d-none');
				}
			});
		}

		var updatePriceWc = function(element) {
			var format = wNumb({
				suffix: ' €',
				mark: ',',
				decimals: 2,
				thousand: '.'
			});

			var formatDot = wNumb({
				suffix: '',
				mark: '.',
				decimals: 2,
				thousand: ''
			});

			var formatComa = wNumb({
				suffix: '',
				mark: ',',
				decimals: 2,
				thousand: ''
			});

			var formatedDot = parseFloat($('#custom-price-wc').val().replace(',', '.'));
			console.log($('#custom-price-wc').val(), formatedDot)
			var formatedComa = $('#custom-price-wc').val().replace('.', ',');
			$('#custom-price-wc').val(formatedComa);


			var service = 0;
			$('[data-kt-element="item"]').each(function() {
				if($(this).find('[data-kt-element="type"]').length > 0 && $(this).find('[data-kt-element="type"]').val() == 'service') {
					service += $(this).find('[data-kt-element="quantity"]').val() * parseFloat($(this).find('[data-kt-element="price"]').val().replace('.', '').replace(',', '.'));
				}
			});

			var actual_price = parseFloat($('[data-kt-element="total-htva"]').html().replace('.', '').replace(' €', '')) - service;
			var new_price = parseFloat($('#wc').html().replace('.', '').replace(' Wc', '')) * formatedDot - service;

			if(isNaN(formatedDot) || formatedDot == '') {
				// location.reload()
				console.log(parseFloat($('#custom-price-wc').val()));
			}
			else {
				var coef = new_price / actual_price;
			}

			
			$('[data-kt-element="item"]').each(function() {
				if($(this).find('[data-kt-element="type"]').length > 0 && $(this).find('[data-kt-element="type"]').val() == 'product') {
					if($(this).find('[data-kt-element="ratio"]').val() == 1) {
						var new_price = parseFloat($(this).find('[data-kt-element="price-ref"]').val().replace('.', '').replace(',', '.')) * coef;
						$(this).find('[data-kt-element="price-ref"]').val(new_price.toFixed(2).replace('.', ','));
					}
					else {
						var new_price = parseFloat($(this).find('[data-kt-element="price"]').val().replace('.', '').replace(',', '.')) * coef;
						$(this).find('[data-kt-element="price"]').val(format.to(new_price));
					}
				}
			});
		}

		var handleEmptyState = function() {
			if (form.querySelectorAll('[data-kt-element="items"] [data-kt-element="item"]').length === 0) {
				var item = form.querySelector('[data-kt-element="empty-template"] tr').cloneNode(true);
				form.querySelector('[data-kt-element="items"] tbody').appendChild(item);
			} else {
				KTUtil.remove(form.querySelector('[data-kt-element="items"] [data-kt-element="empty"]'));
			}
		}

		var handeForm = function (element) {
			// Add item
			form.querySelector('[data-kt-element="items"] [data-kt-element="add-item"]').addEventListener('click', function(e) {
				e.preventDefault();

				var item = form.querySelector('[data-kt-element="item-template"] tr').cloneNode(true);

				form.querySelector('[data-kt-element="items"] tbody').appendChild(item);


				getProduct();
				handleEmptyState();
				updateTotal();			
			});

			// Remove item
			KTUtil.on(form, '[data-kt-element="items"] [data-kt-element="remove-item"]', 'click', function(e) {
				e.preventDefault();

				KTUtil.remove(this.closest('[data-kt-element="item"]'));

				handleEmptyState();
				updateTotal();			
			});		

			// Handle price and quantity changes
			KTUtil.on(form, '[data-kt-element="items"] [data-kt-element="quantity"], [data-kt-element="items"] [data-kt-element="price"], [data-kt-element="vat"], [data-kt-element="items"] [data-kt-element="optional"]', 'change', function(e) {
				e.preventDefault();

				if($(this).data('kt-element') == 'price') {
					var custom_price = true;
				}
				else {
					var custom_price = false;
				}

				updateTotal(custom_price);			
			});	

			// Handle €e/Wc changes
			KTUtil.on(form, '#custom-price-wc', 'change', function(e) {
				e.preventDefault();

				updatePriceWc();
				updateTotal();				
			});	

			if($('#update-price').length > 0) {
				document.getElementById('update-price').addEventListener('click', function(e) {
					e.preventDefault();
					updatePrice();
					updateTotal();			
				});
			}

			KTUtil.on(form, '[name="productible"]', 'change', function(e) {
				e.preventDefault();
				updatePrice();
				updateTotal();		

			});

			// Handle price and quantity changes
			KTUtil.on(form, '[name="quote-date"]', 'change', function(e) {
				e.preventDefault();
				var start_format = $('[name="quote-date"]').val();

				var start_date = start_format.split('-');
				start_date = start_date[1]+"/"+start_date[0]+"/"+start_date[2];
				start_format = new Date(start_date);

			 	var new_start_at = moment(start_format).format('YYYY-MM-DD');
				var next = moment(new_start_at).add(15, 'days').format('DD-MM-YYYY');
				$('[name="quote-due-date"]').val(next);		
			});
		}

		var getProduct = function() {
			$('[data-kt-element="items"] .get-product').each(function() {
				var $this = $(this);
				if($this.closest('tr').attr('id') === undefined){
					var id = 'get-product-'+Math.random();
					$this.closest('tr').attr('id', id);
				}

				$this.easyAutocomplete({
					url: function(phrase) {
						return path+'request/xhr/product/get-product.php?token='+token;
					},

					getValue: 'name',

					list: {
						maxNumberOfElements: 8,
						match: {
							enabled: true
						},
						onClickEvent: function() {
							var id = $this.getSelectedItemData().id;
							var price = $this.getSelectedItemData().price;
							var price_ref = $this.getSelectedItemData().price;
							var vat = $this.getSelectedItemData().vat;
							var wc = $this.getSelectedItemData().wc;
							var type = $this.getSelectedItemData().type;
							var category = $this.getSelectedItemData().category;
							var ratio = $this.getSelectedItemData().ratio;
							// var productible = $this.getSelectedItemData().productible;

							$this.closest('tr').find('[data-kt-element="id"]').val(id);
							$this.closest('tr').find('[data-kt-element="price"]').val(price);
							$this.closest('tr').find('[data-kt-element="price-ref"]').val(price_ref);
							$this.closest('tr').find('[data-kt-element="vat"]').val(vat);
							$this.closest('tr').find('[data-kt-element="wc"]').val(wc);
							$this.closest('tr').find('[data-kt-element="type"]').val(type);
							$this.closest('tr').find('[data-kt-element="category"]').val(category);
							$this.closest('tr').find('[data-kt-element="ratio"]').val(ratio);
							if(productible > 0) {
								// $('#productible').val(productible);
							}

							updateTotal();
						}
					},

					ajaxSettings: {
						dataType: "json",
						method: "POST",
						data: {
					  		dataType: "json"
						}
					},

					preparePostData: function(data) {
						data.phrase = $(".get-product").val();
						return data;
					},
					adjustWidth: false,
					requestDelay: 300
				});
			});
		}

		var initForm = function(element) {
			// Due date. For more info, please visit the official plugin site: https://flatpickr.js.org/
			var invoiceDate = $(form.querySelector('[name="quote-date"]'));
			invoiceDate.flatpickr({
				dateFormat: "d-m-Y",
				'locale' : {
			    	"firstDayOfWeek": 1 // start week on Monday
				}, 
				static: true,
				locale: 'fr',
				plugins: [
				    ShortcutButtonsPlugin({
			      		button: [
					        {
				          		label: "Today"
					        }
				      	],
				      	onClick: (index, fp) => {
			        		fp.setDate(moment(new Date()).format("DD/MM/YYYY"));
			      		}
				    })
			  	]
			});

	        // Due date. For more info, please visit the official plugin site: https://flatpickr.js.org/
			var dueDate = $(form.querySelector('[name="quote-due-date"]'));
			dueDate.flatpickr({
				dateFormat: "d-m-Y",
				'locale' : {
			    	"firstDayOfWeek": 1 // start week on Monday
				}, 
				static: true,
				locale: 'fr',
				plugins: [
				    ShortcutButtonsPlugin({
			      		button: [
					        {
				          		label: "Today"
					        }
				      	],
				      	onClick: (index, fp) => {
			        		fp.setDate(moment(new Date()).format("DD/MM/YYYY"));
			      		}
				    })
			  	]
			});

			getProduct();
			checkPriceUpdate();
		}

		// Public methods
		return {
			init: function(element) {
	            form = document.querySelector('#quote-form');
				handeForm();
	            initForm();
	            // getOpportunity();
	            // getProduct();
				updateTotal();
	        }
		};
	}();

	// On document ready
	KTUtil.onDOMContentLoaded(function () {
		if($('#quote-form').length > 0) {
		    KTAppInvoicesCreate.init();
		}
	});
	 
});

$(document).on('click', '#next-meeting', function() {
    $('#open-map').modal('show');
	var mapOptions = {
		center: { lat: 50.557963, lng: 4.4907088 }, // Set the initial center of the map
		zoom: 10, // Set the initial zoom level
		mapId: 'a0e5e0f1225e313c'
    };
    
    var map = new google.maps.Map(document.getElementById('map'), mapOptions);

    // Load JSON data using jQuery's getJSON
    $.getJSON(path+'request/xhr/opportunity/get-appointment.php?token='+token+'&lat='+$('#contact-map').data('lat')+'&lng='+$('#contact-map').data('lng'), function(data) {

		// Loop through the JSON data and create markers
		$.each(data.markers, function(index, marker) {
			var markerOptions = {
				position: new google.maps.LatLng(marker.lat, marker.lng),
				map: map,
				title: marker.title,
				icon: marker.icon, // You can specify a custom icon for each marker
			};

			var marker = new google.maps.Marker(markerOptions);

			// Add click event listener to display marker info
			marker.addListener('click', function() {
				var infowindow = new google.maps.InfoWindow({
					content: marker.title,
				});
				infowindow.open(map, marker);
			});
		});
    });

})

if($('#client-map').length > 0) {
	var mapOptions = {
		center: { lat: 50.6678628, lng: 4.5497275 }, // Set the initial center of the map
		zoom: 10, // Set the initial zoom level
		mapId: 'a0e5e0f1225e313c'
    };
    
    var map = new google.maps.Map(document.getElementById('client-map'), mapOptions);

    // Load JSON data using jQuery's getJSON
    $.getJSON(path+'request/xhr/home/get-client-map.php?token='+token, function(response) {

    	$('#count-workiste').html(response.count);

		// Loop through the JSON data and create markers
		$.each(response.markers, function(index, marker) {
			var markerOptions = {
				position: new google.maps.LatLng(marker.lat, marker.lng),
				map: map,
				title: marker.title,
				icon: marker.icon, // You can specify a custom icon for each marker
			};

			var marker = new google.maps.Marker(markerOptions);

			// Add click event listener to display marker info
			marker.addListener('click', function() {
				var infowindow = new google.maps.InfoWindow({
					content: marker.title,
				});
				infowindow.open(map, marker);
			});
		});
    });
}

if($('#contact-map').length > 0 ) {
	function initMap() {



		const map = new google.maps.Map(document.getElementById("contact-map"), {
			zoom: 18,
		    center: { lat: $('#contact-map').data('lat'), lng: $('#contact-map').data('lng') },
		    mapTypeControl: false,
		    zoomControl: false,
			scaleControl: false,
			streetViewControl: true,
			rotateControl: false,
			fullscreenControl: true,
		    mapTypeId: 'hybrid',
			options: {
				gestureHandling: 'greedy'
			}		    
		});
		map.setTilt(45)

		// Create a new image
		var image = new google.maps.MarkerImage(
		  'https://app.suncell.be/dist/assets/img/admin/compass.svg',
		  new google.maps.Size(256, 256), // size of the image
		  new google.maps.Point(0, 0), // origin point of the image
		  new google.maps.Point(128, 125) // anchor point of the image
		);

		// Create a new marker with the image
		var marker = new google.maps.Marker({
		  position: {lat: $('#contact-map').data('lat'), lng: $('#contact-map').data('lng')},
		  map: map,
		  icon: image,
		  visible: false,
		  draggable: true // make it draggable
		});

		// Create the DIV to hold the control and call the CustomControl() constructor passing in this DIV.
	    var customControlDiv = document.createElement('div');
	    var customControl = new CustomControl(customControlDiv, map);

	    customControlDiv.index = 1;
	    map.controls[google.maps.ControlPosition.TOP_LEFT].push(customControlDiv);

	    function CustomControl(controlDiv, map) {

		    // Set CSS for the control border
		    var controlUI = document.createElement('div');
		    controlUI.title = 'Recommencer';
		    controlUI.classList.add("maps-compass-button");
		    controlDiv.appendChild(controlUI);

		    // Set CSS for the control interior
		    var controlText = document.createElement('div');
		    controlText.innerHTML = '<i class="fa-light fa-compass fa-xl"></i>';
		    controlUI.appendChild(controlText);

		    // Setup the click event listeners
		    controlUI.addEventListener('click', () => {
			    if (marker.getVisible()) {
		            marker.setVisible(false);
		        } else {
		            marker.setVisible(true);
		        }
		  	});
		}
	}

	initMap();
}

if($('#full-address').length > 0) {
	// Google place API - autcomplete adresse
	function initializeAutocomplete(id) {
		
		var element = document.getElementById(id);

		var options = {
			//types: ['(cities)']
			types: ['geocode'],
			componentRestrictions: {country: ["be", "lu"]}
		};

		if (element) {
			var autocomplete = new google.maps.places.Autocomplete(element, options);
			google.maps.event.addListener(autocomplete, 'place_changed', onPlaceChanged2);
		}
	}

	function onPlaceChanged2() {

		var place = this.getPlace();

		// console.log(place);  // Uncomment this line to view the full object returned by Google API.
		document.getElementById('street-number').value='';
		// document.getElementById('route').value='';
		document.getElementById('city').value='';
		// document.getElementById('admin_area_2').value='';
		// document.getElementById('admin_area_1').value='';
		// document.getElementById('country').value='';
		// document.getElementById('id_country').value='';
		document.getElementById('postal-code').value='';
		// document.getElementById('place_id').value='';
		document.getElementById('lat').value='';
		document.getElementById('lng').value='';
		var locality = '';
		var sublocality = '';
		var admin_area_2 = '';
		var admin_area_1 = '';
		var postal_code = '';
		var route = '';
		var street_number = '';

		document.getElementById('lat').value=place.geometry.location.lat();
		document.getElementById('lng').value=place.geometry.location.lng();

		for (var i in place.address_components) {
			var component = place.address_components[i];
			
			for (var j in component.types) {  // Some types are ["country", "political"]
				var type_element = document.getElementById(component.types[j]);

				/*if(component.types[j] == 'administrative_area_level_1')	{
					document.getElementById('admin_area_1').value = component.long_name;
					admin_area_1 = component.long_name;
				}

				if(component.types[j] == 'administrative_area_level_2') {
					document.getElementById('admin_area_2').value = component.long_name;
					admin_area_2 = component.long_name;
				}*/

				if(component.types[j] == 'country') {
					document.getElementById('country').value = component.short_name;
				}
				
				
				if(component.types[j] == 'locality' && sublocality == '') {
					locality = component.long_name;
				}

				if(component.types[j] == 'sublocality_level_1') {
					locality = component.long_name;
				}

				if(component.types[j] == 'postal_code') {
					postal_code = component.long_name;
				}

				if(component.types[j] == 'street_number') {
					street_number = component.long_name;
				}

				if(component.types[j] == 'route') {
					route = component.long_name;
				}
				if (type_element) {
					// type_element.value = component.long_name;
				}
			}
		}

		if(google.maps.GeocoderStatus.OK) {		 
			// $('.toast-error').hide();
			// $('#ac_input').removeClass('has-error'); 
		 	// toastr.success('Adresse validée'); 
		 } 
		 else { 
			// toastr.error('Adresse erronée'); 
		}

		/*if(locality!='') {
			document.getElementById('locality_field').innerHTML = locality;
		}
		else if(admin_area_2!='') {
			document.getElementById('locality_field').innerHTML = admin_area_2;
		}
		else if(admin_area_1!='') {
			document.getElementById('locality_field').innerHTML = admin_area_1;
		}*/

		document.getElementById('street').value=route;
		document.getElementById('postal-code').value=postal_code;
		document.getElementById('street-number').value=street_number;
		document.getElementById('city').value=locality;
		// document.getElementById('ac_input').value=place.formatted_address;
		// document.getElementById('place_id').value=place.place_id;
		// document.getElementById('D').value=place.geometry.location.lat();
		// document.getElementById('k').value=place.geometry.location.lng();

	 	// All good
	 	isPlaceChange = isActive = true;
	 }

	 google.maps.event.addDomListener(window, 'load', function() {
	 	initializeAutocomplete('full-address');
	 });
}

//# sourceMappingURL=admin.js.map